import React, { useEffect, useState, useRef } from 'react';

import CloseIcon from "../../assets/images/close.png";

import { getGeneralDashboardData, getDepartmentDashboardData, getComplianceDashboardData } from "../../store/actions/dashboardActions";
import {getIncidents_Report_ByCompliance, getActions_Report_ByCompliance, getControls_Report_ByCompliance, getRisks_Report_ByCompliance, getRisks_Report, getControls_Report, getActions_Report, getIncidents_Report, getLevels } from "../../store/actions/riskActions";

import { connect } from "react-redux";
import { compose } from "redux";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import RiskByDepartment from '../Charts/General/RiskByDepartment';
import RiskLevelByDepartment from '../Charts/General/RiskLevelByDepartment';
import RiskLineChart from '../Charts/General/RiskLineChart';
import RiskAppetite from '../Charts/General/RiskAppetite';
import RiskSummary from '../Charts/Department/RiskSummary';
import RiskSummaryReport from '../Charts/Department/RiskSummary_Report';
import TopRisks from '../Charts/Department/TopRisks';
import ActionStatus from '../Charts/Department/ActionStatus';

import Card7 from './Components/Card7';

import spinner from "../../assets/images/loader_blue.svg";
import spinner_white from "../../assets/images/loader_white.svg";

import mountain from "../../assets/images/mountain.jpeg";
import greenMountain from "../../assets/images/GreenMountain.png";
import page1chart from "../../assets/images/page1chart.png";
import page2chart from "../../assets/images/page2chart.png";
import page3chart from "../../assets/images/page3chart.png";
import page4chart from "../../assets/images/page4chart.png";
import page5chart from "../../assets/images/page5chart.png";

import ContentEditable from 'react-contenteditable'
import { getReports, getReport, createReport, deleteReport } from "../../store/actions/reportActions";



import { generatePDF } from '../../utils/pdf';
import { GeneratePDF } from '../../utils/pdfExport';
import { generateReportJSON } from "../../utils/reportUtils";

import "./ReportOverlay.css";


import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";

import moment from 'moment';



// const quillModules = {
//     toolbar: [
//       ["bold", "italic", "underline"], // Basic text styles
//       [{ size: ["small", false, "large"] }], // Font sizes
//       [{ align: [] }], // Text alignment
//       [{ list: "ordered" }, { list: "bullet" }], // Lists
//     ],
//   };



const getBadge = (value, type, data) => {
    let backgroundColor;
    if (value <= 2) {
        backgroundColor = 'bg-BADGE_1';
    } else if (value > 2 && value <= 6) {
        backgroundColor = 'bg-BADGE_2';
    } else if (value > 6 && value <= 12) {
        backgroundColor = 'bg-BADGE_3';
    } else {
        backgroundColor = 'bg-BADGE_4';
    }

    const financialHistory = data.financial_history ? data.financial_history[type] : null;
    const operationalHistory = data.operational_history ? data.operational_history[type] : null;
    const reputationalHistory = data.reputational_history ? data.reputational_history[type] : null;

    const financial = data.financial ? data.financial[type] : null;
    const operational = data.operational ? data.operational[type] : null;
    const reputational = data.reputational ? data.reputational[type] : null;

    let historyFinancial = financialHistory !== null ? (financialHistory - financial > 0 ? ArrowDownGreen : financialHistory - financial < 0 ? ArrowUpRed : Nill) : null;
    let historyOperational = operationalHistory !== null ? (operationalHistory - operational > 0 ? ArrowDownGreen : operationalHistory - operational < 0 ? ArrowUpRed : Nill) : null;
    let historyReputational = reputationalHistory !== null ? (reputationalHistory - reputational > 0 ? ArrowDownGreen : reputationalHistory - reputational < 0 ? ArrowUpRed : Nill) : null;

    return `
        <div class="badge ${backgroundColor} flex items-center justify-center text-center p-2 rounded-[5px] text-white whitespace-nowrap overflow-hidden text-ellipsis min-w-[55px]">
            <span>${value}</span>
            ${type === 'inherent' ? `<img src="${historyFinancial}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
            ${type === 'residual' ? `<img src="${historyOperational}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
            ${type === 'future' ? `<img src="${historyReputational}" alt="Arrow" class="w-4 h-4 ml-1" />` : ''}
        </div>
    `;
}





const calculateFinancialLoss = (impact, levels) => {
    const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Find the corresponding riskImpact based on the impact value
    const riskImpact = levels.riskImpacts?.find((item) => item.impact === impact);

    if (riskImpact) {
        // Calculate the average of financial_low and financial_high
        const average = (riskImpact.financial_low + riskImpact.financial_high) / 2;
        return formatNumber(Math.round(average)); // Round and format the number
    }

    // Default to 0 if no matching impact is found
    return formatNumber(0);
};


const ReportOverlay = ({ getIncidents_Report_ByComplianceFN, getActions_Report_ByComplianceFN, getControls_Report_ByComplianceFN, getRisks_Report_ByComplianceFN, activeComplianceId, activeDepartment, department_id, closeReport, getGeneralDashboardDataFN, getComplianceDashboardDataFN, general_dashboard_data, getDepartmentDashboardDataFN, department_dashboard_data, getRisks_ReportFN, risks_report, getControls_ReportFN, risk_controls, getActions_ReportFN, risk_actions, getIncidents_ReportFN, getLevelsFN, risk_incidents, findings, createReportFN, getReportFN, getReportsFN, deleteReportFN, levels, propData, is_new }) => {




    useEffect(() => {
        ////console.log("New Report?")
        if (is_new) {
            ////console.log("New Report!")
            const json = generateReportJSON(editableName, {
                page4subtitle4,
                page5subtitle3,
                table3data2,
                table4data,
            });
            ////console.log(json)
            createReportFN(json.editableName.title, json, 3)


            // Call the save function passed from the page
            //onSave(json);
        }
    }, [is_new]);
    // const [isEditing, setIsEditing] = useState(false);

    // const quillModules = isEditing
    //   ? {
    //       toolbar: [
    //         ["bold", "italic", "underline"],
    //         [{ size: ["small", false, "large"] }],
    //         [{ align: [] }],
    //         [{ list: "ordered" }, { list: "bullet" }],
    //       ],
    //     }
    //   : { toolbar: false }; // No toolbar when not editing

    const [activeBox, setActiveBox] = useState(null); // Tracks the active text box
    const editorRef = useRef(null);

    const componentRef = useRef(null);
    ////////console.log("levels report", levels);

    const getImpactDefinition = (impact) => {
        const impactDefinition = levels.riskImpacts?.find(item => item.impact === impact);
        return impactDefinition || { operational: "N/A", financial: "N/A", reputational: "N/A" };
    };

    const getProbabilityDefinition = (probability) => {
        //////console.log("probability", probability)
        if (probability === "Almost Certain") {
            probability = "Almost certain"
        }
        const probabilityDefinition = levels.riskProbabilities?.find(item => item.scale === probability);
        return probabilityDefinition || { scale: "N/A", controls: "N/A", frequency: "N/A" };
    };

    const [language, setLanguage] = React.useState('tr');

    const [loading, setLoading] = useState(true);
    const [parsing, setParsing] = useState(is_new);
    const [dropdownOpen, setDropdownOpen] = useState(false);



    useEffect(() => {
        if (propData) {
            loadReportJSON(propData);
            setParsing(true);
        }
    }, [propData]);

    const translations = {
        en: {
            title: "Q3 - REPORT",
            subtitle: "Comprehensive Risk Insights: Identifying, Mitigating, and Strategically Managing the Top Threats to Secure Our Organization’s Future 01/10/2024",
            page1title: "1-EXECUTIVE SUMMARY",
            page1subtitle1: "Objectives",
            page1subtitle2: "Identify, Assess, Mitigate, and Monitor – Empowering Strategic Decisions and Ensuring Resilience.",
            page1subtitle3: "Objectives of an ERM risk report include identifying and categorizing risks, assessing their impact and likelihood, monitoring trends, recommending mitigation strategies, supporting strategic decision-making, and ensuring compliance and accountability.",
            page1subtitle4: "Key Highlights",
            page1subtitle5: "Key highlights of this report include a comprehensive identification and categorization of current and emerging risks across the organization, with detailed assessments of each risk’s potential impact and likelihood. We provide actionable mitigation strategies aimed at reducing vulnerability and enhancing resilience. Trends in risk exposure are monitored to keep pace with evolving challenges, and insights are aligned with organizational objectives to support strategic decision-making. Additionally, our approach emphasizes compliance and accountability, ensuring that all risk management activities are transparent, well-documented, and aligned with regulatory standards. This proactive and structured approach positions the organization for sustainable growth and operational security.",
            page2title: "2-RISK ENVIRONMENT OVERVIEW",
            page2subtitle1: "Climate Change and Catastrophe Exposure:",
            page2subtitle2: "Climate-related events remain a primary concern, as extreme weather patterns—including floods, hurricanes, and wildfires—drive higher-than-anticipated claims frequency and severity. Increased climate volatility continues to test the accuracy of catastrophe modeling tools and strains resources for loss recovery. Rising demands for parametric insurance products indicate a shift towards more adaptable insurance solutions, but also introduce challenges in risk quantification and pricing.",
            page2subtitle3: "Geopolitical Uncertainty:",
            page2subtitle4: "Global political tensions and regulatory shifts in key markets, including Europe and North America, have introduced uncertainty for multinational reinsurance programs. Sanctions, trade restrictions, and geopolitical conflicts may impact the availability of reinsurance for certain sectors, such as energy and infrastructure. Emerging markets, where regulatory frameworks are evolving, present both growth opportunities and heightened regulatory risk, as new compliance standards must be met across diverse jurisdictions.",
            page2subtitle5: "Regulatory and Compliance:",
            page2subtitle6: "Heightened regulatory scrutiny on data privacy, solvency requirements, and transparency in reinsurance transactions has necessitated increased compliance monitoring and reporting efforts.",
            page2subtitle7: "Cybersecurity Threats:",
            page2subtitle8: "Increasing sophistication in cyberattacks poses a substantial risk to operational continuity, client data protection, and financial stability. Cyber risks are not only a concern for internal operations but also for client portfolios, as demand for cyber reinsurance products grows.",
            page3title: "3-STRATEGY AND OBJECTIVE",
            page3subtitle1: "Risk Appetite, Risk Category",
            page3subtitle2: "Risk Appetite Definition",
            page3subtitle3: "Risk appetite refers to the types and amount of risk, on a broad level, that the organization is willing to accept in pursuit of value. Neither appetite nor risk tolerance — the acceptable levels of variation in performance related to business objectives — is typically defined at the risk-specific level.",
            page3subtitle4: `<ul>        <li class="list-item">            <div class="circle averse"></div>            <strong>Averse: No Risk Appetite</strong> – Prioritizes security and stability, actively avoiding risks and favoring highly controlled environments.        </li>        <li class="list-item">            <div class="circle minimalist"></div>            <strong>Minimalist: Very Low Risk Appetite</strong> – Focuses on essential, low-impact risks, maintaining a lean approach to risk-taking, only as necessary.        </li>        <li class="list-item">            <div class="circle cautious"></div>            <strong>Cautious: Low Risk Appetite</strong> – Takes calculated risks with substantial preventive measures, preferring known outcomes with minimal uncertainty.        </li>        <li class="list-item">            <div class="circle open"></div>            <strong>Open: Moderate Risk Appetite</strong> – Willing to take some risks, considering innovative opportunities while balancing potential gains and losses.        </li>        <li class="list-item">            <div class="circle hungry"></div>            <strong>Hungry: High Risk Appetite</strong> – Actively seeks risk for the potential of high rewards, tolerating significant uncertainty and variability in outcomes.        </li>    </ul>`,
            page3subtitle5: "Risk Category Definition",
            page3subtitle6: `   <ul style="list-style-type: disc; padding-left: 20px; margin: 0;">        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Operational Risks:</strong> Potential disruption of business operations from plant shutdowns, suspensions, debarments, and loss of license.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Financial Risks:</strong> Internal and external costs associated with investigating and remediation (e.g., legal fees, consultants, investigators).        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Strategic Risks:</strong> Prohibition to add new customers, loss of license.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Compliance Risks:</strong> Report on regulatory compliance risks and any new requirements.        </li>        <li style="margin-bottom: 10px;font-weight: normal;">            <strong>Reputational Risks:</strong> Effect of media coverage; damage to organization’s image/brand; and subsequent diminished attractiveness to current and potential future employees, business partners, vendors, and customers.        </li>    </ul>`,
            page4title: "4-PERFORMANCE",
            page4subtitle1: "Method and severity of risk",
            page4subtitle2: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;">        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Inherent Risk:</strong> The level of risk that exists before any controls or mitigating actions are applied. It represents the raw, unaltered level of exposure to a particular threat or vulnerability.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Residual Risk:</strong> The level of risk that remains after controls and mitigating actions have been implemented. It reflects the organization's exposure after measures are taken to reduce or manage inherent risks.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Future Risk:</strong> The Future Risk or Target Risk Level refers to the level of risk that an organization aims to achieve or maintain in the future, considering upcoming changes, emerging trends, or potential unforeseen events.        </li>    </ul>    <p style="margin-bottom:20px"><strong>Key Distinction</strong></p>    <ul style="list-style-type: disc; padding-left: 20px;">        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Inherent Risk:</strong> Initial state of risk, pre-mitigation.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Residual Risk:</strong> Post-mitigation, the remaining risk.        </li>        <li style="margin-bottom: 10px;font-weight:normal">            <strong>Future Risk:</strong> Accepted risk level.        </li>    </ul>`,
            page4subtitle3: `<p style="font-weight:normal"><b>Likelihood of occurrence</b> refers to the probability or chance that a specific risk event will happen.</p>`,
            // page4subtitle4: `<table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal">        <thead style="background-color: #2E7D32 !important; color: black;">            <tr style="background-color: #2E7D32 !important; color: black;">                <th style="padding: 10px; border: 1px solid #ddd;">Likelihood</th>                <th style="padding: 10px; border: 1px solid #ddd;">Frequency</th>                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>            </tr>        </thead>        <tbody>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #336699;margin-right:10px"></div> Rare                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Less than once in 10 years</td>                <td style="padding: 10px;  border: 1px solid #ddd;">1</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <span style="width: 15px; height: 15px; border-radius: 50%; background-color: #66CCCC; margin-right: 10px;"></span> Unlikely                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once in 10 years</td>                <td style="padding: 10px; border: 1px solid #ddd;">2</td>            </tr>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <span style="width: 15px; height: 15px; border-radius: 50%; background-color: #FFCC99; margin-right: 10px;"></span> Possible                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once in 5 years</td>                <td style="padding: 10px; border: 1px solid #ddd;">3</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #CC6666; margin-right: 10px;"></div> Likely                </td>                <td style="padding: 10px; border: 1px solid #ddd;">At least once per year</td>                <td style="padding: 10px; border: 1px solid #ddd;">4</td>            </tr>            <tr>                <td style="padding: 10px; width:618px; border: 1px solid #ddd; vertical-align: middle;">                    <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #990033; margin-right: 10px;"></div> Almost certain                </td>                <td style="padding: 10px; border: 1px solid #ddd;">More than once per year</td>                <td style="padding: 10px; border: 1px solid #ddd;">5</td>            </tr>        </tbody>    </table>`,
            page5title: "5-KEY RISK CATEGORIES",
            page5subtitle1: "Severity of risk",
            page5subtitle2: "Operational, Financial, Reputational Risks Impact",
            //page5subtitle3: `<table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd;font-weight:normal">        <thead>            <tr style="background-color: #CC6666; color: black;">                <th style="padding: 10px; border: 1px solid #ddd;">Impact</th>                <th style="padding: 10px; border: 1px solid #ddd;">Operational</th>                <th style="padding: 10px; border: 1px solid #ddd;">Financial</th>                <th style="padding: 10px; border: 1px solid #ddd;">Reputational</th>                <th style="padding: 10px; border: 1px solid #ddd;">Strategic</th>                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>            </tr>        </thead>        <tbody>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #336699; margin-right: 10px;"></div>                        <strong>Insignificant</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in hours</td>                <td style="padding: 10px; border: 1px solid #ddd;">&lt;$100K</td>                <td style="padding: 10px; border: 1px solid #ddd;">No impact</td>                <td style="padding: 10px; border: 1px solid #ddd;">No impact</td>                <td style="padding: 10px; border: 1px solid #ddd;">1</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #66CCCC; margin-right: 10px;"></div>                        <strong>Minor</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in days</td>                <td style="padding: 10px; border: 1px solid #ddd;">$100K-$1M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Only company employees informed</td>                <td style="padding: 10px; border: 1px solid #ddd;">Minor impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">2</td>            </tr>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #FFCC99; margin-right: 10px;"></div>                        <strong>Moderate</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Operation can be recovered in one week</td>                <td style="padding: 10px; border: 1px solid #ddd;">$1M-$5M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Complaints from customer</td>                <td style="padding: 10px; border: 1px solid #ddd;">Major impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">3</td>            </tr>            <tr style="background-color: #f9f9f9;">                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #CC6666; margin-right: 10px;"></div>                        <strong>Major</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Disruption over a week</td>                <td style="padding: 10px; border: 1px solid #ddd;">$5M-$15M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Reported in social and sectoral media</td>                <td style="padding: 10px; border: 1px solid #ddd;">Significant impact to pursue goals</td>                <td style="padding: 10px; border: 1px solid #ddd;">4</td>            </tr>            <tr>                <td style="padding: 10px; border: 1px solid #ddd;">                    <div style="display: flex; align-items: center;">                        <div style="width: 15px; height: 15px; border-radius: 50%; background-color: #990033; margin-right: 10px;"></div>                        <strong>Catastrophe</strong>                    </div>                </td>                <td style="padding: 10px; border: 1px solid #ddd;">Disruption over a month</td>                <td style="padding: 10px; border: 1px solid #ddd;">&gt;$15M</td>                <td style="padding: 10px; border: 1px solid #ddd;">Reported in mass media and administrative sanction</td>                <td style="padding: 10px; border: 1px solid #ddd;">Loss license</td>                <td style="padding: 10px; border: 1px solid #ddd;">5</td>            </tr>        </tbody>    </table>`,
            page5subtitle4: `The organization’s risk appetite would also be reflected in setting the values used in the anchor labels. An additional factor that may enhance the evaluation of severity is the localization or regionalization of the assessment. For multilocation and multinational organizations, risk may vary from one location or region to another, based on a wide variety of factors. `,
            page5subtitle5: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;font-weight:normal">        <li style="margin-bottom: 10px;">            <strong>Purpose:</strong> Visualize and categorize risks to prioritize which ones require more attention.        </li>        <li style="margin-bottom: 10px;">            <strong>Matrix Design:</strong> A typical matrix includes “Likelihood” on one axis and “Impact” on the other, with the resulting cells indicating a low, medium, or high overall risk.        </li>        <li style="margin-bottom: 10px;">            <strong>Prioritization:</strong> Risks in the high-likelihood, high-impact quadrant are top priorities, while low-likelihood, low-impact risks may require minimal action.        </li>    </ul>`,
            page6title: "6-COMPANY RISK LEVEL",
            page6subtitle1: "Performance",
            page6subtitle2: "This section presents the company’s general risk profile, including departmental risk counts, inherent risk levels, and risk appetite. A five-quarter time series shows inherent, residual, and future risk levels, helping track risk trends and assess alignment with the company's acceptable risk threshold across departments.",
            page6subtitle3: `<p style="font-weight:bold">Residual risk by departments:</p>
<p style="font-weight:normal">Residual risk is the amount of risk that remains after all risk controls and mitigation efforts have been implemented. In other words, it's the level of exposure that persists even after preventive, detective, and corrective measures are in place. We use residual risk as a KPI of risk awareness reflects how well employees and the organization recognize and address potential risks, highlighting a proactive approach to risk management.</p>
<p style="font-weight:normal">The charts indicate that the marketing and finance departments have higher levels of residual risk, highlighting the need for greater focus and improvement in these departments.</p>`,
            page6subtitle4: `<p style="font-weight:bold">General risk level by time:</p>
<p style="font-weight:normal">The above graph shows the average inherent risks, residual risks and future risks of the company in 5 quarters. During the reporting period, the inherent risks and residual risks of the company have decreased compared to the previous period. Our company has made serious progress in reducing risks.</p>`,
            page6subtitle5: `<p style="font-weight:bold">Risk appetite:</p>
<p style="font-weight:normal">Our company mostly operates with a minimalist risk appetite, prioritizing only essential and low-impact risks. This lean approach ensures that our risk-taking is deliberate and necessary, aligning with our core objectives and preserving organizational stability.</p>`,
            page7title: "7-DEPARTMENTAL DETAIL",
            page7subtitle1: "An overview of the general risk levels across the department is presented in this section, highlighting key statistics and assessments. A list of strategic risks that may impact long-term goals is also outlined, ensuring preparedness to address these challenges and maintain alignment with the broader business strategy.",
            page7subtitle2: "Risk by department",
            page7subtitle3: "This section provides an overview of the inherent, residual, and future risk levels for financial, operational, and reputational risks. The primary key performance indicator (KPI) is the effectiveness of mitigation strategies, evaluated based on the ability to reduce inherent risks to future risk levels. ",
            page8title: "8.LOW RISK",
            page8subtitle1: "8.1.Risk Assessment and Analysis",
            page8subtitle2: "This section comprises risks that have been mitigated to an acceptable level, based on their inherent, residual, and future risk evaluations. These risks, while previously higher in severity, have been reduced through effective controls and interventions.",
            page8subtitle3: "Ongoing monitoring ensures that these risks remain within acceptable thresholds, with measures in place to address any potential changes in the risk landscape.The goal is to maintain these risks at a manageable level, ensuring the continued stability and resilience of the organization.",
            page8subtitle4: "8.2. Control and Mitigations",
            page8subtitle5: "The strategies and measures implemented to address high-risk areas across financial, operational, and reputational risks are outlined. For each identified risk, the effectiveness of the controls in place to reduce their likelihood and impact has been assessed. Findings from the evaluation process are presented, along with recommendations for enhancing control measures to further mitigate high-risk levels.",
            page8subtitle6: "8.3. Action Plan and Timeline",
            page8subtitle7: "For risks that have been successfully reduced to acceptable levels, no further action is required at this stage. These risks are considered adequately mitigated, and efforts will focus on ongoing monitoring to ensure they remain within acceptable thresholds.",
            page9title: "9-HIGH RISK",
            page9subtitle1: "9.1.Risk Assessment and Analysis",
            page9subtitle2: "After implementing control measures, we have identified that some of certain financial, operational, and reputational risks still remain at a high-risk level. These risks are considered critical, requiring further attention and more robust mitigation strategies to prevent them from impacting the department’s objectives.",
            page9subtitle3: "Continuous monitoring and a proactive approach are essential to managing and reducing these risks to acceptable levels.",
            page9subtitle4: "9.2. Control and Mitigations",
            page9subtitle5: "The strategies and measures implemented to address high-risk areas across financial, operational, and reputational risks are outlined. For each identified risk, the effectiveness of the controls in place to reduce their likelihood and impact has been assessed. Findings from the evaluation process are presented, along with recommendations for enhancing control measures to further mitigate high-risk levels.",
            page9subtitle6: "9.3. Action Plan and Timeline",
            page9subtitle7: "All actions taken to address identified risks, along with their respective start and due times, are outlined. The progress of each action is tracked, with its status indicated as completed, in progress, or facing challenges. This section provides an overview of the timeline for each action, ensuring alignment of risk mitigation efforts with objectives and deadlines.",
            page9subtitle8: "By regularly updating the status of each action, we can ensure that necessary adjustments are made and maintain transparency in the execution of our risk management plan.",
            page10title: "10-INCIDENTS",
            page10subtitle1: "Incidents that occurred during this reporting period are shown in this section.",
            page11title: "CONCLUSION",
            page11subtitle1: `<p class="mb-4">      As part of our ongoing risk management efforts, the following provides a summary of the key findings, actions taken, and future steps for addressing financial, operational, and reputational risks.    </p>    <ol class="list-decimal list-inside space-y-3">      <li>        A thorough assessment of the organization’s financial, operational, and reputational risks has been completed, providing a clear view of the current risk landscape.      </li>      <li>        The effectiveness of implemented controls has been evaluated, showing significant reductions in risk levels. Several risks have successfully been mitigated from high to moderate or low levels, indicating that control measures have been largely effective.      </li>      <li>        Despite the progress, certain risks, particularly in operational and reputational areas, still require ongoing attention. These areas necessitate continuous monitoring and refinement of controls to align with the company’s risk tolerance and ensure long-term stability.      </li>      <li>        Specific recommendations have been provided to address the remaining high-risk areas. These suggestions focus on enhancing the current controls and implementing new measures where necessary to further reduce the likelihood and impact of these risks.      </li>      <li>        An action plan has been put in place, with clearly defined actions and timelines for each risk area. These actions aim to further mitigate the risks and ensure that they remain within acceptable levels.      </li>      <li>        Moving forward, the organization will continue to prioritize risk management, focusing on maintaining risks at acceptable levels. Any changes in the risk environment will be promptly addressed to ensure that the company’s risk exposure remains within acceptable boundaries.      </li>    </ol>`,
        }, tr: {
            title: "Q3 - RAPOR",
            subtitle: "Kapsamlı Risk İçgörüleri: Kurumumuzun Geleceğini Güvence Altına Almak için Tehditleri Belirleme, Azaltma ve Stratejik Yönetim 01/10/2024",
            page1title: "1-YÖNETİCİ ÖZETİ",
            page1subtitle1: "Hedefler",
            page1subtitle2: "Tanımlama, Değerlendirme, Azaltma ve İzleme – Stratejik Kararları Güçlendirme ve Dayanıklılığı Sağlama.",
            page1subtitle3: "ERM risk raporunun hedefleri arasında riskleri tanımlama ve kategorize etme, etki ve olasılıklarını değerlendirme, trendleri izleme, azaltma stratejileri önerme, stratejik karar vermeyi destekleme ve uyum ve hesap verebilirliği sağlama yer alır.",
            page1subtitle4: "Önemli Noktalar",
            page1subtitle5: "Bu raporun önemli noktaları arasında, kuruluş genelindeki mevcut ve gelişmekte olan risklerin kapsamlı bir şekilde tanımlanması ve kategorize edilmesi, her riskin potansiyel etkisinin ve olasılığının detaylı değerlendirmeleri yer almaktadır. Kırılganlığı azaltmayı ve dayanıklılığı artırmayı amaçlayan uygulanabilir azaltma stratejileri sunuyoruz. Gelişen zorluklarla başa çıkabilmek için risk maruziyetindeki eğilimler izleniyor ve içgörüler stratejik karar vermeyi desteklemek için kurumsal hedeflerle uyumlu hale getiriliyor. Ek olarak, yaklaşımımız tüm risk yönetimi faaliyetlerinin şeffaf, iyi belgelenmiş ve düzenleyici standartlarla uyumlu olmasını sağlayarak uyum ve hesap verebilirliği vurgulamaktadır. Bu proaktif ve yapılandırılmış yaklaşım, kuruluşu sürdürülebilir büyüme ve operasyonel güvenlik için konumlandırmaktadır.",

            page2title: "2-RİSK ORTAMI GENEL BAKIŞI",
            page2subtitle1: "İklim Değişikliği ve Felaket Maruziyeti:",
            page2subtitle2: "Sel, kasırga ve orman yangınları dahil olmak üzere aşırı hava koşulları beklenenden daha yüksek talep sıklığı ve şiddetine neden olduğundan, iklimle ilgili olaylar birincil endişe kaynağı olmaya devam ediyor. Artan iklim değişkenliği, felaket modelleme araçlarının doğruluğunu test etmeye ve kayıp kurtarma kaynaklarını zorlamaya devam ediyor. Parametrik sigorta ürünlerine yönelik artan talepler, daha uyarlanabilir sigorta çözümlerine doğru bir kayma olduğunu gösteriyor, ancak risk ölçümü ve fiyatlandırmada zorluklar da beraberinde geliyor.",
            page2subtitle3: "Jeopolitik Belirsizlik:",
            page2subtitle4: "Avrupa ve Kuzey Amerika dahil olmak üzere kilit pazarlardaki küresel siyasi gerilimler ve düzenleyici değişiklikler, çok uluslu reasürans programları için belirsizlik getirmiştir. Yaptırımlar, ticaret kısıtlamaları ve jeopolitik çatışmalar, enerji ve altyapı gibi belirli sektörler için reasürans bulunabilirliğini etkileyebilir. Düzenleyici çerçevelerin gelişmekte olduğu yeni pazarlar, farklı yargı alanlarında yeni uyum standartlarının karşılanması gerektiğinden hem büyüme fırsatları hem de artan düzenleyici risk sunmaktadır.",
            page2subtitle5: "Düzenleyici ve Uyum:",
            page2subtitle6: "Veri gizliliği, ödeme gücü gereksinimleri ve reasürans işlemlerinde şeffaflık konusundaki artan düzenleyici inceleme, artan uyum izleme ve raporlama çabalarını gerekli kılmıştır.",
            page2subtitle7: "Siber Güvenlik Tehditleri:",
            page2subtitle8: "Siber saldırılardaki artan karmaşıklık, operasyonel süreklilik, müşteri veri koruması ve finansal istikrar için önemli bir risk oluşturuyor. Siber riskler sadece iç operasyonlar için değil, siber reasürans ürünlerine olan talep arttıkça müşteri portföyleri için de bir endişe kaynağıdır.",

            page3title: "3-STRATEJİ VE HEDEF",
            page3subtitle1: "Risk İştahı, Risk Kategorisi",
            page3subtitle2: "Risk İştahı Tanımı",
            page3subtitle3: "Risk iştahı, kuruluşun değer yaratma arayışında geniş düzeyde kabul etmeye istekli olduğu risk türlerini ve miktarını ifade eder. Ne iştah ne de risk toleransı — iş hedefleriyle ilgili performanstaki kabul edilebilir değişim seviyeleri — tipik olarak riske özgü düzeyde tanımlanmaz.",
            page3subtitle4: `<ul>
                <li class="list-item">
                    <div class="circle averse"></div>
                    <strong>Kaçınan: Risk İştahı Yok</strong> – Güvenlik ve istikrarı önceliklendirir, risklerden aktif olarak kaçınır ve yüksek kontrollü ortamları tercih eder.
                </li>
                <li class="list-item">
                    <div class="circle minimalist"></div>
                    <strong>Minimalist: Çok Düşük Risk İştahı</strong> – Sadece gerekli olduğunda, temel, düşük etkili risklere odaklanır, risk almada yalın bir yaklaşım sürdürür.
                </li>
                <li class="list-item">
                    <div class="circle cautious"></div>
                    <strong>Temkinli: Düşük Risk İştahı</strong> – Önemli önleyici tedbirlerle hesaplanmış riskler alır, minimum belirsizlikle bilinen sonuçları tercih eder.
                </li>
                <li class="list-item">
                    <div class="circle open"></div>
                    <strong>Açık: Orta Risk İştahı</strong> – Potansiyel kazanç ve kayıpları dengelerken yenilikçi fırsatları değerlendirerek bazı riskleri almaya isteklidir.
                </li>
                <li class="list-item">
                    <div class="circle hungry"></div>
                    <strong>Hırslı: Yüksek Risk İştahı</strong> – Yüksek ödüller potansiyeli için aktif olarak risk arar, sonuçlarda önemli belirsizlik ve değişkenliği tolere eder.
                </li>
            </ul>`,
            page3subtitle5: "Risk Kategorisi Tanımı",
            page3subtitle6: `<ul style="list-style-type: disc; padding-left: 20px; margin: 0;">
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Operasyonel Riskler:</strong> Tesis kapanmaları, askıya almalar, yasaklamalar ve lisans kaybından kaynaklanan potansiyel iş operasyonları kesintisi.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Finansal Riskler:</strong> Soruşturma ve iyileştirme ile ilgili iç ve dış maliyetler (örn. yasal ücretler, danışmanlar, araştırmacılar).
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Stratejik Riskler:</strong> Yeni müşteri ekleme yasağı, lisans kaybı.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>Uyum Riskleri:</strong> Düzenleyici uyum riskleri ve yeni gereksinimleri raporlama.
                </li>
                <li style="margin-bottom: 10px;font-weight: normal;">
                    <strong>İtibar Riskleri:</strong> Medya kapsamının etkisi; kuruluşun imajına/markasına zarar; ve sonuç olarak mevcut ve potansiyel gelecekteki çalışanlar, iş ortakları, tedarikçiler ve müşteriler için azalan çekicilik.
                </li>
            </ul>`,

            page4title: "4-PERFORMANS",
            page4subtitle1: "Risk yöntemi ve şiddeti",
            page4subtitle2: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;">
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Doğal Risk:</strong> Herhangi bir kontrol veya azaltıcı eylem uygulanmadan önce var olan risk seviyesi. Belirli bir tehdit veya güvenlik açığına karşı ham, değiştirilmemiş maruziyet seviyesini temsil eder.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Kalıntı Risk:</strong> Kontroller ve azaltıcı eylemler uygulandıktan sonra kalan risk seviyesi. Doğal riskleri azaltmak veya yönetmek için önlemler alındıktan sonra kuruluşun maruziyetini yansıtır.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Gelecek Risk:</strong> Gelecek Risk veya Hedef Risk Seviyesi, bir kuruluşun gelecekte yaklaşan değişiklikleri, ortaya çıkan trendleri veya potansiyel öngörülemeyen olayları göz önünde bulundurarak ulaşmayı veya sürdürmeyi amaçladığı risk seviyesini ifade eder.
                </li>
            </ul>
            <p style="margin-bottom:20px"><strong>Temel Ayrım</strong></p>
            <ul style="list-style-type: disc; padding-left: 20px;">
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Doğal Risk:</strong> Azaltma öncesi başlangıç risk durumu.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Kalıntı Risk:</strong> Azaltma sonrası kalan risk.
                </li>
                <li style="margin-bottom: 10px;font-weight:normal">
                    <strong>Gelecek Risk:</strong> Kabul edilen risk seviyesi.
                </li>
            </ul>`,
            page4subtitle3: `<p style="font-weight:normal"><b>Gerçekleşme olasılığı</b> belirli bir risk olayının gerçekleşme olasılığını veya şansını ifade eder.</p>`,

            page5title: "5-TEMEL RİSK KATEGORİLERİ",
            page5subtitle1: "Risk şiddeti",
            page5subtitle2: "Operasyonel, Finansal, İtibar Riskleri Etkisi",
            page5subtitle4: "Kuruluşun risk iştahı, çapa etiketlerinde kullanılan değerlerin belirlenmesinde de yansıtılacaktır. Şiddet değerlendirmesini geliştirebilecek ek bir faktör, değerlendirmenin yerelleştirilmesi veya bölgeselleştirilmesidir. Çok lokasyonlu ve çok uluslu kuruluşlar için risk, çok çeşitli faktörlere bağlı olarak bir lokasyondan veya bölgeden diğerine değişebilir.",
            page5subtitle5: `<ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 20px;font-weight:normal">
                <li style="margin-bottom: 10px;">
                    <strong>Amaç:</strong> Hangi risklerin daha fazla dikkat gerektirdiğini önceliklendirmek için riskleri görselleştirme ve kategorize etme.
                </li>
                <li style="margin-bottom: 10px;">
                    <strong>Matris Tasarımı:</strong> Tipik bir matris, bir eksende "Olasılık" ve diğerinde "Etki" içerir, sonuçta oluşan hücreler düşük, orta veya yüksek genel riski gösterir.
                </li>
                <li style="margin-bottom: 10px;">
                    <strong>Önceliklendirme:</strong> Yüksek olasılık, yüksek etki çeyreğindeki riskler en öncelikli iken, düşük olasılık, düşük etki riskleri minimal eylem gerektirebilir.
                </li>
            </ul>`,

            page6title: "6-ŞİRKET RİSK SEVİYESİ",
            page6subtitle1: "Performans",
            page6subtitle2: "Bu bölüm, departmansal risk sayıları, doğal risk seviyeleri ve risk iştahı dahil olmak üzere şirketin genel risk profilini sunar. Beş çeyreklik bir zaman serisi, doğal, kalıntı ve gelecek risk seviyelerini göstererek risk trendlerini takip etmeye ve departmanlar genelinde şirketin kabul edilebilir risk eşiği ile uyumunu değerlendirmeye yardımcı olur.",
            page6subtitle3: `<p style="font-weight:bold">Departmanlara göre kalıntı risk:</p>
        <p style="font-weight:normal">Kalıntı risk, tüm risk kontrolleri ve azaltma çabaları uygulandıktan sonra kalan risk miktarıdır. Başka bir deyişle, önleyici, tespit edici ve düzeltici önlemler alındıktan sonra bile devam eden maruziyet seviyesidir. Risk farkındalığının bir KPI'sı olarak kalıntı riski kullanıyoruz, çalışanların ve kuruluşun potansiyel riskleri nasıl tanıdığını ve ele aldığını, risk yönetimine proaktif bir yaklaşımı vurgulayarak yansıtır.</p>
        <p style="font-weight:normal">Grafikler, pazarlama ve finans departmanlarının daha yüksek kalıntı risk seviyelerine sahip olduğunu gösteriyor, bu departmanlarda daha fazla odaklanma ve iyileştirme ihtiyacını vurguluyor.</p>`,
            page6subtitle4: `<p style="font-weight:bold">Zamana göre genel risk seviyesi:</p>
        <p style="font-weight:normal">Yukarıdaki grafik, şirketin 5 çeyrekteki ortalama doğal riskleri, kalıntı riskleri ve gelecek risklerini göstermektedir. Raporlama döneminde, şirketin doğal riskleri ve kalıntı riskleri önceki döneme göre azalmıştır. Şirketimiz riskleri azaltma konusunda ciddi ilerleme kaydetmiştir.</p>`,
            page6subtitle5: `<p style="font-weight:bold">Risk iştahı:</p>
        <p style="font-weight:normal">Şirketimiz çoğunlukla minimalist bir risk iştahıyla çalışır, sadece temel ve düşük etkili risklere öncelik verir. Bu yalın yaklaşım, risk almamızın bilinçli ve gerekli olmasını sağlar, temel hedeflerimizle uyumlu olur ve kurumsal istikrarı korur.</p>`,

            page7title: "7-DEPARTMAN DETAYI",
            page7subtitle1: "Bu bölümde, departman genelindeki genel risk seviyelerine ilişkin bir genel bakış sunularak, temel istatistikler ve değerlendirmeler vurgulanmaktadır. Uzun vadeli hedefleri etkileyebilecek stratejik risklerin bir listesi de bu zorlukları ele almaya hazırlıklı olmak ve daha geniş iş stratejisiyle uyumu sürdürmek için ana hatlarıyla belirtilmiştir.",
            page7subtitle2: "Departmana göre risk",
            page7subtitle3: "Bu bölüm, finansal, operasyonel ve itibar riskleri için doğal, kalıntı ve gelecek risk seviyelerine genel bir bakış sağlar. Temel performans göstergesi (KPI), doğal riskleri gelecek risk seviyelerine düşürme yeteneğine dayalı olarak değerlendirilen azaltma stratejilerinin etkinliğidir.",

            page8title: "8-DÜŞÜK RİSK",
            page8subtitle1: "8.1.Risk Değerlendirmesi ve Analizi",
            page8subtitle2: "Bu bölüm, doğal, kalıntı ve gelecek risk değerlendirmelerine dayanarak kabul edilebilir bir seviyeye indirilmiş riskleri içerir. Daha önce şiddeti daha yüksek olan bu riskler, etkili kontroller ve müdahaleler yoluyla azaltılmıştır.",
            page8subtitle3: "Sürekli izleme, bu risklerin kabul edilebilir eşikler içinde kalmasını sağlar, risk ortamındaki potansiyel değişiklikleri ele almak için önlemler mevcuttur. Amaç, bu riskleri yönetilebilir bir seviyede tutarak, kuruluşun sürekli istikrarını ve dayanıklılığını sağlamaktır.",
            page8subtitle4: "8.2. Kontrol ve Azaltmalar",
            page8subtitle5: "Finansal, operasyonel ve itibar riskleri genelinde yüksek riskli alanları ele almak için uygulanan stratejiler ve önlemler ana hatlarıyla belirtilmiştir. Tanımlanan her risk için, olasılıklarını ve etkilerini azaltmak üzere mevcut kontrollerin etkinliği değerlendirilmiştir. Değerlendirme sürecinden elde edilen bulgular, yüksek risk seviyelerini daha da azaltmak için kontrol önlemlerini geliştirmeye yönelik önerilerle birlikte sunulmuştur.",
            page8subtitle6: "8.3. Eylem Planı ve Zaman Çizelgesi",
            page8subtitle7: "Kabul edilebilir seviyelere başarıyla indirilen riskler için bu aşamada başka bir eylem gerekmemektedir. Bu riskler yeterince azaltılmış kabul edilir ve çabalar, kabul edilebilir eşikler içinde kalmalarını sağlamak için sürekli izlemeye odaklanacaktır.",

            page9title: "9-YÜKSEK RİSK",
            page9subtitle1: "9.1.Risk Değerlendirmesi ve Analizi",
            page9subtitle2: "Kontrol önlemleri uygulandıktan sonra, bazı finansal, operasyonel ve itibar risklerinin hala yüksek risk seviyesinde kaldığını tespit ettik. Bu riskler kritik kabul edilir, departmanın hedeflerini etkilemelerini önlemek için daha fazla dikkat ve daha sağlam azaltma stratejileri gerektirir.",
            page9subtitle3: "Bu riskleri yönetmek ve kabul edilebilir seviyelere indirmek için sürekli izleme ve proaktif bir yaklaşım esastır.",
            page9subtitle4: "9.2. Kontrol ve Azaltmalar",
            page9subtitle5: "Finansal, operasyonel ve itibar riskleri genelinde yüksek riskli alanları ele almak için uygulanan stratejiler ve önlemler ana hatlarıyla belirtilmiştir. Tanımlanan her risk için, olasılıklarını ve etkilerini azaltmak üzere mevcut kontrollerin etkinliği değerlendirilmiştir. Değerlendirme sürecinden elde edilen bulgular, yüksek risk seviyelerini daha da azaltmak için kontrol önlemlerini geliştirmeye yönelik önerilerle birlikte sunulmuştur.",
            page9subtitle6: "9.3. Eylem Planı ve Zaman Çizelgesi",
            page9subtitle7: "Tanımlanan riskleri ele almak için alınan tüm eylemler, ilgili başlangıç ve bitiş süreleriyle birlikte ana hatlarıyla belirtilmiştir. Her eylemin ilerlemesi izlenir, durumu tamamlandı, devam ediyor veya zorluklar yaşıyor olarak belirtilir. Bu bölüm, risk azaltma çabalarının hedefler ve son tarihlerle uyumunu sağlayarak her eylem için zaman çizelgesine genel bir bakış sağlar.",
            page9subtitle8: "Her eylemin durumunu düzenli olarak güncelleyerek, gerekli ayarlamaların yapıldığından emin olabilir ve risk yönetim planımızın uygulanmasında şeffaflığı koruyabiliriz.",

            page10title: "10-OLAYLAR",
            page10subtitle1: "Bu raporlama döneminde gerçekleşen olaylar bu bölümde gösterilmektedir.",

            page11title: "SONUÇ",
            page11subtitle1: `<p class="mb-4">Süregelen risk yönetimi çabalarımızın bir parçası olarak, aşağıda finansal, operasyonel ve itibar risklerini ele almak için temel bulgular, alınan eylemler ve gelecek adımların bir özeti sunulmaktadır.</p>
            <ol class="list-decimal list-inside space-y-3">
              <li>Kuruluşun finansal, operasyonel ve itibar risklerinin kapsamlı bir değerlendirmesi tamamlanmış, mevcut risk ortamının net bir görünümü sağlanmıştır.</li>
              <li>Uygulanan kontrollerin etkinliği değerlendirilmiş, risk seviyelerinde önemli azalmalar görülmüştür. Birçok risk başarıyla yüksek seviyeden orta veya düşük seviyelere indirilmiş, bu da kontrol önlemlerinin büyük ölçüde etkili olduğunu göstermektedir.</li>
              <li>Kaydedilen ilerlemeye rağmen, özellikle operasyonel ve itibar alanlarındaki bazı riskler sürekli dikkat gerektirmektedir. Bu alanlar, şirketin risk toleransı ile uyumlu olmak ve uzun vadeli istikrarı sağlamak için kontrollerin sürekli izlenmesini ve iyileştirilmesini gerektirmektedir.</li>
              <li>Kalan yüksek riskli alanları ele almak için özel öneriler sunulmuştur. Bu öneriler, bu risklerin olasılığını ve etkisini daha da azaltmak için mevcut kontrolleri geliştirmeye ve gerektiğinde yeni önlemler uygulamaya odaklanmaktadır.</li>
              <li>Her risk alanı için açıkça tanımlanmış eylemler ve zaman çizelgeleri içeren bir eylem planı oluşturulmuştur. Bu eylemler, riskleri daha da azaltmayı ve kabul edilebilir seviyelerde kalmalarını sağlamayı amaçlamaktadır.</li>
              <li>İleriye dönük olarak, kuruluş risk yönetimine öncelik vermeye, riskleri kabul edilebilir seviyelerde tutmaya odaklanmaya devam edecektir. Risk ortamındaki herhangi bir değişiklik, şirketin risk maruziyetinin kabul edilebilir sınırlar içinde kalmasını sağlamak için hızla ele alınacaktır.</li>
            </ol>`
        }
    };

    const [updateTrigger, setUpdateTrigger] = React.useState(0);

    const editableName = React.useRef(JSON.parse(JSON.stringify(translations[language])));

    React.useEffect(() => {
        if (is_new === true) {
            editableName.current = translations[language];
            // Force a re-render by updating trigger
            setUpdateTrigger(prev => prev + 1);
        }
    }, [language]);


    const [page4subtitle4, setPage4subtitle4] = React.useState("");
    const [page5subtitle3, setPage5subtitle3] = React.useState("");


    // Add language selector if not already present
    const handleLanguageChange = (e) => {
        //////console.log(`changed language to ${e.target.value}`);
        setLanguage(e.target.value);
    };


    React.useEffect(() => {
        if (levels?.riskProbabilities) {
            const backgroundColors = ['#990033', '#CC6666', '#FFCC99', '#66CCCC', '#336699'];
            ////console.log("levels.riskProbabilities", levels.riskProbabilities)
            const tableRows = levels.riskProbabilities
                .map((item, index) => `
    <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : 'transparent'};">
      <td style="padding: 10px; width:618px; border: 1px solid #ddd; font-size: 12px;">
        <div style="display: flex; align-items: center;">
          <div style="
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background-color: ${backgroundColors[item.id - 1]};
              margin-right: 10px;
          "></div>
          <span>${item.scale}</span>
        </div>
      </td>
      <td style="padding: 10px; border: 1px solid #ddd;">${item.frequency}</td>
      <td style="padding: 10px; border: 1px solid #ddd;">${item.id}</td>
    </tr>
  `)
                .join('');

            const tableHTML = language === "en" ? `
                    <table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal; font-size: 12px;">
                        <thead style="background-color: #2E7D32 !important; color: black;">
                            <tr style="background-color: #2E7D32 !important; color: black;">
                                <th style="padding: 10px; border: 1px solid #ddd;">Likelihood</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Frequency</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                ` : `
                    <table style="border-collapse: collapse; width: 100%; text-align: left;font-weight:normal; font-size: 12px;">
                        <thead style="background-color: #2E7D32 !important; color: black;">
                            <tr style="background-color: #2E7D32 !important; color: black;">
                                <th style="padding: 10px; border: 1px solid #ddd;">Olasılık</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Frekans</th>
                                <th style="padding: 10px; border: 1px solid #ddd;">Skor</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                `;
            ////console.log(tableHTML)
            setPage4subtitle4(tableHTML); // Set the state with the generated HTML
        }
    }, [levels, language]);

    React.useEffect(() => {
        if (levels?.riskImpacts) {
            const backgroundColors = ['#336699', '#66CCCC', '#FFCC99', '#CC6666', '#990033'];

            const tableRows = levels.riskImpacts
                .map((item, index) => `
                        <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#ffffff'};">
                            <td style="padding: 6px; border: 1px solid #ddd; text-align: left; vertical-align: top; font-size: 12px; width: 20%;">
                                <div style="display: flex; align-items: center;">
                                    <div style="width: 12px; height: 12px; border-radius: 50%; background-color: ${backgroundColors[item.id - 1]}; margin-right: 6px;"></div>
                                    <strong>${item.impact}</strong>
                                </div>
                            </td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.operational}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">$${item.financial_low} - $${item.financial_high}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.reputational}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; vertical-align: top; font-size: 12px; width: 20%;">${item.strategic}</td>
                            <td style="padding: 6px; border: 1px solid #ddd; text-align: center; vertical-align: top; font-size: 12px; width: 10%;">${item.id}</td>
                        </tr>
                    `)
                .join('');

            const tableHTML = language === "en" ? `
                    <table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd; font-weight: normal; table-layout: fixed; font-size: 12px;">
                        <thead style="background-color: #CC6666; color: black;">
                            <tr>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Impact</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Operational</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Financial</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Reputational</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Strategic</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: center; font-size: 12px; width: 10%;">Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                ` : `
                    <table style="border-collapse: collapse; width: 100%; text-align: left; border: 1px solid #ddd; font-weight: normal; table-layout: fixed; font-size: 12px;">
                        <thead style="background-color: #CC6666; color: black;">
                            <tr>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Etkilenme</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Operasyonel</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Finansal</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">İtibar</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: left; font-size: 12px; width: 20%;">Stratejik</th>
                                <th style="padding: 6px; border: 1px solid #ddd; text-align: center; font-size: 12px; width: 10%;">Skor</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                `;

            setPage5subtitle3(tableHTML); // Set the state with the generated HTML
        }
    }, [levels]);


    const total_risks = general_dashboard_data?.risk_level_by_department?.map(department => department.totalRisks).reduce((a, b) => a + b, 0) || 0;
    //const top_department_names = general_dashboard_data?.risk_level_by_department?.[0]?.name || "N/D";

    // const { toPDF, targetRef } = usePDF({ filename: 'report.pdf' });

    const [table1data, setTable1data] = React.useState("");
    const [table1data2, setTable1data2] = React.useState("");

    const [table2data1, setTable2data] = React.useState("");
    const [table2data2, setTable2data2] = React.useState("");
    const [table3data1, setTable3data] = React.useState("");
    const [table3data2, setTable3data2] = React.useState("");
    const [table4data, setTable4data] = React.useState("");
    const [table5data, setTable5data] = React.useState("");
    const [table7data, setTable7data] = React.useState("");
    const [table7data1, setTable7data1] = React.useState("");


    const [totalRisks, settotalRisks] = React.useState("");

    React.useEffect(() => {

        //console.log("activeComplianceId ", activeComplianceId)
        getGeneralDashboardDataFN();
        //getDepartmentDashboardDataFN(department_id);
        getComplianceDashboardDataFN(activeComplianceId);
        getRisks_Report_ByComplianceFN(activeComplianceId);
        getControls_Report_ByComplianceFN(activeComplianceId);
        getActions_Report_ByComplianceFN(activeComplianceId);
        getIncidents_Report_ByComplianceFN(activeComplianceId);
        getLevelsFN();

        //console.log("Running this")

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //////////console.log(activeDepartment);
    React.useEffect(() => {
        if (general_dashboard_data) {

            // should be switched to last use effect
            setTimeout(() => {
                setLoading(false);
            }, 1200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [general_dashboard_data]);

    React.useEffect(() => {
        if (department_dashboard_data) {
            ////////console.log(department_dashboard_data);
            setTimeout(() => {
                setLoading(false);
            }, 1200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department_dashboard_data]);


    React.useEffect(() => {
        ////////console.log("report risk: ", risks_report);
        if (risks_report) {
            settotalRisks(risks_report?.length)
        }


    }, [risks_report]);

    ////////console.log("Risk report: ", risks_report);
    React.useEffect(() => {
        ////////console.log("report risk: ", risks_report);
        if (risks_report) {
            //console.log("risk_report ", risks_report);

            let table1data = language === "en" ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Title</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Owner</th>
         
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Strategic Impact</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Level</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Likelihood</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Financial Impact</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Operational Impact</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Reputation Impact</th>
 
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Financial Risk</th>
          <th class="border border-gray-300 px-2 py-2 text-left report-th">Operational Risk</th>
          <th class="border border-gray-300 px-1 py-2 text-left report-th">Reputational Risk</th>
        </tr>
      </thead>
      <tbody>` : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Başlığı</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Sahibi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Stratejik Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Seviyesi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Olasılık</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Finansal Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Operasyonel Etki</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">İtibar Etkisi</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Finansal Risk</th>
          <th class="border border-gray-300 px-2 py-2 text-left report-th">Operasyonel Risk</th>
          <th class="border border-gray-300 px-1 py-2 text-left report-th">İtibar Riski</th>
        </tr>
      </thead>
      <tbody>`;

            let table1data2 = table1data;

            risks_report.forEach(risk => {
                if (risk.financial.residual <= 6 && risk.operational.residual <= 6 && risk.reputational.residual <= 6) {
                    table1data += `
                <!-- First Row: Contains the Data -->
                <tr class="bg-white text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                    
                    <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">Inherent</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getProbabilityDefinition(risk.probability_inherent).frequency}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">$${calculateFinancialLoss(risk.financial_inherent, levels)}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getImpactDefinition(risk.operational_inherent).operational}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getImpactDefinition(risk.reputational_inherent).reputational}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.financial.inherent, "inherent", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.operational.inherent, "inherent", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.reputational.inherent, "inherent", risk)}</td>
                </tr>
                <!-- Second Row: Empty Cells for Simulated Rowspan -->
                <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.ID}</td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.Title}</td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.OwnerFirstName} ${risk.OwnerLastName}</td>
                   
                    <td class="border-l border-gray-300 px-4 py-2 no-border">${getImpactDefinition(risk.StrategicImpact).strategic}</td>
                    <td class="border border-gray-300 px-4 py-2">Residual</td>
                    <td class="border border-gray-300 px-4 py-2">${getProbabilityDefinition(risk.probability_residual).frequency}</td>
                    <td class="border border-gray-300 px-4 py-2">$${calculateFinancialLoss(risk.financial_residual, levels)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.operational_residual).operational}</td>
                    <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.reputational_residual).reputational}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.financial.residual, "residual", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.operational.residual, "residual", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.reputational.residual, "residual", risk)}</td>
                </tr>
                <!-- Third Row: Empty Cells for Simulated Rowspan -->
                <tr class="bg-white text-gray-800 no-horizontal-lines">
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                  
                    <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                    <td class="border border-gray-300 px-4 py-2">Future</td>
                    <td class="border border-gray-300 px-4 py-2">${getProbabilityDefinition(risk.probability_future).frequency}</td>
                    <td class="border border-gray-300 px-4 py-2">$${calculateFinancialLoss(risk.financial_future, levels)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.operational_future).operational}</td>
                    <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.reputational_future).reputational}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.financial.future, "future", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.operational.future, "future", risk)}</td>
                    <td class="border border-gray-300 px-4 py-2">${getBadge(risk.reputational.future, "future", risk)}</td>
                </tr>`;
                }

                else {
                    table1data2 += `
                    <!-- First Row: Contains the Data -->
                    <tr class="bg-white text-gray-800 no-horizontal-lines">
                        <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                        <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                        <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                       
                        <td class="border-l border-gray-300 px-4 py-2 no-bottom-border fixed-height report-td"></td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">Inherent</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getProbabilityDefinition(risk.probability_inherent).frequency}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${calculateFinancialLoss(risk.financial_inherent, levels)}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getImpactDefinition(risk.operational_inherent).operational}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getImpactDefinition(risk.reputational_inherent).reputational}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.financial.inherent, "inherent", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.operational.inherent, "inherent", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2 fixed-height">${getBadge(risk.reputational.inherent, "inherent", risk)}</td>
                    </tr>
                    <!-- Second Row: Empty Cells for Simulated Rowspan -->
                    <tr class="bg-gray-100 text-gray-800 no-horizontal-lines">
                        <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.ID}</td>
                        <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.Title}</td>
                        <td class="border-l border-gray-300 px-4 py-2 no-border">${risk.OwnerFirstName} ${risk.OwnerLastName}</td>
                       
                        <td class="border-l border-gray-300 px-4 py-2 no-border">${getImpactDefinition(risk.StrategicImpact).strategic}</td>
                        <td class="border border-gray-300 px-4 py-2">Residual</td>
                        <td class="border border-gray-300 px-4 py-2">${getProbabilityDefinition(risk.probability_residual).frequency}</td>
                        <td class="border border-gray-300 px-4 py-2">$${calculateFinancialLoss(risk.financial_residual, levels)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.operational_residual).operational}</td>
                        <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.reputational_residual).reputational}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.financial.residual, "residual", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.operational.residual, "residual", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.reputational.residual, "residual", risk)}</td>
                    </tr>
                    <!-- Third Row: Empty Cells for Simulated Rowspan -->
                    <tr class="bg-white text-gray-800 no-horizontal-lines">
                        <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                        <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                        <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                       
                        <td class="border-l border-gray-300 px-4 py-2 no-border"></td>
                        <td class="border border-gray-300 px-4 py-2">Future</td>
                        <td class="border border-gray-300 px-4 py-2">${getProbabilityDefinition(risk.probability_future).frequency}</td>
                        <td class="border border-gray-300 px-4 py-2">$${calculateFinancialLoss(risk.financial_future, levels)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.operational_future).operational}</td>
                        <td class="border border-gray-300 px-4 py-2">${getImpactDefinition(risk.reputational_future).reputational}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.financial.future, "future", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.operational.future, "future", risk)}</td>
                        <td class="border border-gray-300 px-4 py-2">${getBadge(risk.reputational.future, "future", risk)}</td>
                    </tr>`;
                }

            });

            table1data += `</tbody>
            
    </table>`;

            table1data2 += `</tbody>
            
    </table>`;


            setTable1data(table1data);
            setTable1data2(table1data2);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risks_report, language]);

    ////////console.log("report controls", risk_controls);
   React.useEffect(() => {
  if (risk_controls) {
    // 1) Table header – with <colgroup> to control relative widths
  let table2data1 =
  language === "en"
    ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <colgroup>
        <col style="width: 8%;" />   <!-- Risk ID -->
        <col style="width: 18%;" />  <!-- Risk Title -->
        <col style="width: 18%;" />  <!-- Control Title (smaller now) -->
        <col style="width: 10%;" />  <!-- Control Type -->
        <col style="width: 8%;" />   <!-- Efficiency -->
        <col style="width: 19%;" />  <!-- Finding (bigger) -->
        <col style="width: 19%;" />  <!-- Recommendation (bigger) -->
      </colgroup>
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Title</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Title</th>  <!-- swapped -->
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Type</th>  <!-- swapped -->
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Efficiency</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Finding</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Recommendation</th>
        </tr>
      </thead>
      <tbody>`
    : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
      <colgroup>
        <col style="width: 8%;" />   <!-- Risk ID -->
        <col style="width: 18%;" />  <!-- Risk Başlığı -->
        <col style="width: 18%;" />  <!-- Kontrol Başlığı (smaller) -->
        <col style="width: 10%;" />  <!-- Kontrol Tipi -->
        <col style="width: 8%;" />   <!-- Verimlilik -->
        <col style="width: 19%;" />  <!-- Bulgu -->
        <col style="width: 19%;" />  <!-- Öneri -->
      </colgroup>
      <thead>
        <tr class="bg-red-200 text-gray-800 font-bold">
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk Başlığı</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Başlığı</th>  <!-- swapped -->
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Tipi</th>     <!-- swapped -->
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Verimliliği</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Bulgu</th>
          <th class="border border-gray-300 px-4 py-2 text-left report-th">Öneri</th>
        </tr>
      </thead>
      <tbody>`;


    // second table same header
    let table2data2 = table2data1;

    // 2) Iterate each risk
    risk_controls.forEach((risk) => {
      const isLowResidual =
        risk.residualScores?.financial <= 6 &&
        risk.residualScores?.operational <= 6 &&
        risk.residualScores?.reputational <= 6;

      const controlsArr = Array.isArray(risk.controls) ? risk.controls : [];

      // 3) One row per control (WITH findings / recommendations again)
      controlsArr.forEach((ctrl, index) => {
        const targetTable = isLowResidual ? "low" : "high";

        const eff = ctrl?.efficiencyLevel;
        const isThumbUp =
          index === 0 ? eff > 50 || !eff : eff > 75 || !eff;

        const efficiencyIcon = isThumbUp
          ? "<i class='fas fa-thumbs-up'></i>"
          : "<i class='fas fa-frown'></i>";

        const controlTitle =
          ctrl?.controlDetails ||
          ctrl?.controlTitle ||
          ctrl?.title ||
          "N/A";

        // ---- NEW PART: first finding only ----
        const findingsArr = Array.isArray(ctrl?.findings) ? ctrl.findings : [];
        const firstFinding = findingsArr[0];

        // assuming finding object has .description and .recommendation
        const findingText =
          firstFinding && firstFinding.description
            ? firstFinding.description
            : language === "en"
            ? "No findings identified."
            : "Herhangi bir bulgu tespit edilmemiştir.";

        const recommendationText =
          firstFinding && firstFinding.recommendation
            ? firstFinding.recommendation
            : language === "en"
            ? "No recommendation specified."
            : "Herhangi bir öneri belirtilmemiştir.";

       const rowHtml = `
  <tr class="bg-white text-gray-800">
    <td class="border-l border-gray-300 px-4 py-2 fixed-height report-td">${risk.riskId}</td>
    <td class="border-l border-gray-300 px-4 py-2 fixed-height report-td">${risk.title}</td>

    <!-- CONTROL TITLE first now -->
    <td class="border border-gray-300 px-4 py-2 bg-white">
      ${controlTitle}
    </td>

    <!-- CONTROL TYPE second -->
    <td class="border border-gray-300 px-4 py-2 bg-white">
      ${ctrl?.controlType || "N/A"}
    </td>

    <td class="border border-gray-300 px-4 py-2 bg-white text-[#3b3b3b]">${efficiencyIcon}</td>
    <td class="border border-gray-300 px-4 py-2 bg-white">${findingText}</td>
    <td class="border border-gray-300 px-4 py-2 bg-white">${recommendationText}</td>
  </tr>`;


        if (targetTable === "low") {
          table2data1 += rowHtml;
        } else {
          table2data2 += rowHtml;
        }
      });
    });

    table2data1 += `</tbody></table>`;
    table2data2 += `</tbody></table>`;

    setTable2data(table2data1);
    setTable2data2(table2data2);
  }
}, [risk_controls, language]);


    React.useEffect(() => {
        if (!risk_controls) return;

        // 1) Table header – with <colgroup> to control relative widths
        let table1data3_low =
            language === "en"
                ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <colgroup>
            <col style="width: 10%;" />  <!-- Risk ID -->
            <col style="width: 14%;" />  <!-- Control ID -->
            <col style="width: 26%;" />  <!-- Control Title -->
            <col style="width: 25%;" />  <!-- Finding Description -->
            <col style="width: 25%;" />  <!-- Finding Recommendation -->
          </colgroup>
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Control ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Control Title</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Finding</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Recommendation</th>
            </tr>
          </thead>
          <tbody>`
                : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
          <colgroup>
            <col style="width: 10%;" />  <!-- Risk ID -->
            <col style="width: 14%;" />  <!-- Kontrol ID -->
            <col style="width: 26%;" />  <!-- Kontrol Başlığı -->
            <col style="width: 25%;" />  <!-- Bulgu -->
            <col style="width: 25%;" />  <!-- Öneri -->
          </colgroup>
          <thead>
            <tr class="bg-red-200 text-gray-800 font-bold">
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Risk ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol ID</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Kontrol Başlığı</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Bulgu</th>
              <th class="border border-gray-300 px-4 py-2 text-left report-th">Öneri</th>
            </tr>
          </thead>
          <tbody>`;

        // second table = same header (for high residual risks)
        let table1data3_high = table1data3_low;

        // 2) Iterate each risk
        risk_controls.forEach((risk) => {
            const isLowResidual =
                risk.residualScores?.financial <= 6 &&
                risk.residualScores?.operational <= 6 &&
                risk.residualScores?.reputational <= 6;

            const controlsArr = Array.isArray(risk.controls) ? risk.controls : [];

            // 3) For each control, loop over all findings
            controlsArr.forEach((ctrl) => {
                const findingsArr = Array.isArray(ctrl.findings) ? ctrl.findings : [];
                if (!findingsArr?.length) return; // skip controls with no findings

                const controlTitle =
                    ctrl?.controlDetails ||
                    ctrl?.controlTitle ||
                    ctrl?.title ||
                    "N/A";

                const controlIdDisplay =
                    ctrl?.controlID ||
                    ctrl?.controlId ||
                    ctrl?.control_id ||
                    "N/A";

                findingsArr.forEach((f) => {
                    const findingDesc = f?.description || "";
                    const findingReco = f?.recommendation || "";

                    const rowHtml = `
          <tr class="bg-white text-gray-800">
            <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">
              ${risk.riskId}
            </td>
            <td class="border-l border-gray-300 px-4 py-2 fixed-height no-bottom-border report-td">
              ${controlIdDisplay}
            </td>
            <td class="border border-gray-300 px-4 py-2 bg-white">
              ${controlTitle}
            </td>
            <td class="border border-gray-300 px-4 py-2 bg-white">
              ${findingDesc}
            </td>
            <td class="border border-gray-300 px-4 py-2 bg-white">
              ${findingReco}
            </td>
          </tr>`;

                    if (isLowResidual) {
                        table1data3_low += rowHtml;
                    } else {
                        table1data3_high += rowHtml;
                    }
                });
            });
        });

        table1data3_low += `</tbody></table>`;
        table1data3_high += `</tbody></table>`;

        setTable7data(table1data3_low);
        setTable7data(table1data3_high);
    }, [risk_controls, language]);




    ////////console.log("risk actions report: ", risk_actions);


React.useEffect(() => {
  if (!risk_actions) return;

  const tableHeader =
    language === "en"
      ? `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
        <colgroup>
          <col style="width: 8%;" />   <!-- Risk ID -->
          <col style="width: 24%;" />  <!-- Risk Title -->
          <col style="width: 30%;" />  <!-- Action Title -->
          <col style="width: 10%;" />  <!-- Start -->
          <col style="width: 10%;" />  <!-- Due -->
          <col style="width: 18%;" />  <!-- Status -->
        </colgroup>
        <thead>
          <tr class="bg-red-200 text-gray-800 font-bold">
            <th class="border border-gray-300 px-4 py-2">Risk ID</th>
            <th class="border border-gray-300 px-4 py-2">Risk Title</th>
            <th class="border border-gray-300 px-4 py-2">Action Title</th>
            <th class="border border-gray-300 px-4 py-2">Start</th>
            <th class="border border-gray-300 px-4 py-2">Due</th>
            <th class="border border-gray-300 px-4 py-2">Status</th>
          </tr>
        </thead>
        <tbody>`
      : `<table class="min-w-full table-auto border-collapse border border-gray-300 report-table">
        <colgroup>
          <col style="width: 8%;" />   
          <col style="width: 24%;" />
          <col style="width: 30%;" />
          <col style="width: 10%;" />
          <col style="width: 10%;" />
          <col style="width: 18%;" />
        </colgroup>
        <thead>
          <tr class="bg-red-200 text-gray-800 font-bold">
            <th class="border border-gray-300 px-4 py-2">Risk ID</th>
            <th class="border border-gray-300 px-4 py-2">Risk Başlığı</th>
            <th class="border border-gray-300 px-4 py-2">Aksiyon Başlığı</th>
            <th class="border border-gray-300 px-4 py-2">Başlangıç</th>
            <th class="border border-gray-300 px-4 py-2">Bitiş</th>
            <th class="border border-gray-300 px-4 py-2">Durum</th>
          </tr>
        </thead>
        <tbody>`;

  let table3data1 = tableHeader;
  let table3data2 = tableHeader;

  risk_actions.forEach((risk) => {
    const isLowResidual =
      risk.residualScores?.financial <= 6 &&
      risk.residualScores?.operational <= 6 &&
      risk.residualScores?.reputational <= 6;

    const actions = Array.isArray(risk.actions) ? risk.actions : [];

    actions.forEach((act) => {
      // ❗️ SKIP if action title does NOT exist
      if (!act?.action_Title || String(act.action_Title).trim() === "") return;

      const actionTitle = act.action_Title;
      const statusText = act?.status || "N/A";

      const start = act.startDate
        ? moment(act.startDate).format("DD/MM/YYYY")
        : "N/A";

      const end = act.endDate
        ? moment(act.endDate).format("DD/MM/YYYY")
        : "N/A";

      const row = `
        <tr class="bg-white text-gray-800">
          <td class="border-l border-gray-300 px-4 py-2">${risk.riskId}</td>
          <td class="border-l border-gray-300 px-4 py-2">${risk.title}</td>

          <td class="border border-gray-300 px-4 py-2 bg-white">${actionTitle}</td>
          <td class="border border-gray-300 px-4 py-2 bg-white">${start}</td>
          <td class="border border-gray-300 px-4 py-2 bg-white">${end}</td>
          <td class="border border-gray-300 px-4 py-2 bg-white">${statusText}</td>
        </tr>`;

      if (isLowResidual) table3data1 += row;
      else table3data2 += row;
    });
  });

  table3data1 += `</tbody></table>`;
  table3data2 += `</tbody></table>`;

  setTable3data(table3data1);
  setTable3data2(table3data2);
}, [risk_actions, language]);




    React.useEffect(() => {
        if (risk_incidents) {
            ////////console.log(risk_incidents);

            let datafortableincidents = "";
            let i = 0;
            risk_incidents.forEach(incident => {
                datafortableincidents += ` <table class="w-full border-collapse border border-gray-300 table-fixed ${i !== risk_incidents?.length - 1 ? "mb-4" : ""}">
  <colgroup>
    <col style="width: 35%;" />
    <col style="width: 65%;" />
  </colgroup>

      <tbody>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Date" : "Olay Tarihi"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${moment(incident.reportDate).format("DD/MM/YYYY")}</td>
        </tr>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Related Risk" : "İlgili Risk"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${incident.risk_id + " - " + incident.title}</td>
        </tr>
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Location" : "Olay Konumu"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">${incident.location}</td>
        </tr>
        <!-- Describe Incident -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Describe Incident" : "Olayı Tanımla"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
            ${incident.description}
          </td>
        </tr>
        <!-- Incident Root Cause -->
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Incident Root Cause" : "Olayın Temel Nedeni"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
${incident.root_cause}
           
          </td>
        </tr>
        <!-- Impact -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Impact" : "Etkiler"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
           ${incident.impact}
          </td>
        </tr>
        <!-- Corrective Action -->
        <tr>
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Corrective Action" : "Düzeltici Eylem"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
            ${incident.corrective_action}
          </td>
        </tr>
        <!-- Preventive Measures -->
        <tr class="bg-gray-100">
          <td class="border border-gray-300 px-4 py-2 font-bold">${language === 'en' ? "Preventive Measures" : "Önleyici Önlemler"}</td>
          <td colspan="2" class="border border-gray-300 px-4 py-2">
           ${incident.preventive_measures}
          </td>
        </tr>
      </tbody>
    </table>`

                i++;
            });

            setTable4data(datafortableincidents);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risk_incidents, language]);


    React.useEffect(() => {
        if (risk_incidents) {
            ////////console.log(risk_incidents);

            let datafortablefindings = findings?.length;
            let i = 0;
            // findings.forEach(incident => {
            //     datafortablefindings += "placeholder"
            // });

            setTable5data(datafortablefindings);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [findings, language]);




    // const currentQuarter = moment().quarter();
    // const quarterString = currentQuarter === 1 ? "Q1" : currentQuarter === 2 ? "Q2" : currentQuarter === 3 ? "Q3" : "Q4";
    // const quarterStarted = moment().startOf('quarter').format("DD/MM/YYYY");
    const currentQuarter = moment().quarter();

    const quarterString = `Q${currentQuarter}`;

    const reportingStartDates = {
        1: "01/04/YYYY",
        2: "01/07/YYYY",
        3: "01/10/YYYY",
        4: "01/01/YYYY"  // of next year
    };

    const currentYear = moment().year();
    const reportYear = currentQuarter === 4 ? currentYear + 1 : currentYear;

    const quarterStarted = reportingStartDates[currentQuarter].replace("YYYY", reportYear);

    const [exporting, setExporting] = React.useState(false);

    const handleExportP = async () => {
        setExporting(true);
        //await GeneratePDF(componentRef);
        setExporting(false);
    }

    const handleExportV = async () => {
        setExporting(true);
        //await generatePDF(componentRef);
        setExporting(false);
    }

    const formatTopRisksParagraph = (risks, language) => {
        const top5 = risks?.slice(0, 5);
        if (language === 'en') {
            const riskList = top5?.map(r => r.title).join(", ").replace(/, ([^,]*)$/, ", and $1");
            return `The following represent the top 5 most critical risks currently facing our department: ${riskList}. These risks pose significant threats to our strategic objectives. It is essential that we prioritize mitigation efforts around them to protect our operations, secure key assets, and ensure long-term resilience and growth.`;
        } else {
            const riskList = top5?.map(r => r.title).join(", ").replace(/, ([^,]*)$/, " ve $1");
            return `Aşağıdakiler, şu anda departmanımızın karşı karşıya olduğu en kritik 5 riski temsil etmektedir: ${riskList}. Bu riskler, stratejik hedeflerimiz için ciddi tehditler oluşturmaktadır. Operasyonlarımızı korumak, kritik varlıkları güvence altına almak ve uzun vadeli dayanıklılık ile büyümeyi sağlamak için bu risklerin azaltılmasına öncelik verilmesi büyük önem taşımaktadır.`;
        }
    };

    const generateReportJSON = () => {
        ////console.log("Generating Json", editableName);
        return {
            editableName: {
                title: editableName.current.title,
                subtitle: editableName.current.subtitle,

                page1title: editableName.current.page1title,
                page1subtitle1: editableName.current.page1subtitle1,
                page1subtitle2: editableName.current.page1subtitle2,
                page1subtitle3: editableName.current.page1subtitle3,
                page1subtitle4: editableName.current.page1subtitle4,
                page1subtitle5: editableName.current.page1subtitle5,

                page2title: editableName.current.page2title,
                page2subtitle1: editableName.current.page2subtitle1,
                page2subtitle2: editableName.current.page2subtitle2,
                page2subtitle3: editableName.current.page2subtitle3,
                page2subtitle4: editableName.current.page2subtitle4,
                page2subtitle5: editableName.current.page2subtitle5,
                page2subtitle6: editableName.current.page2subtitle6,
                page2subtitle7: editableName.current.page2subtitle7,
                page2subtitle8: editableName.current.page2subtitle8,

                page3title: editableName.current.page3title,
                page3subtitle1: editableName.current.page3subtitle1,
                page3subtitle2: editableName.current.page3subtitle2,
                page3subtitle3: editableName.current.page3subtitle3,
                page3subtitle4: editableName.current.page3subtitle4,
                page3subtitle5: editableName.current.page3subtitle5,
                page3subtitle6: editableName.current.page3subtitle6,

                page4title: editableName.current.page4title,
                page4subtitle1: editableName.current.page4subtitle1,
                page4subtitle2: editableName.current.page4subtitle2,
                page4subtitle3: editableName.current.page4subtitle3,

                page5title: editableName.current.page5title,
                page5subtitle1: editableName.current.page5subtitle1,
                page5subtitle2: editableName.current.page5subtitle2,
                page5subtitle4: editableName.current.page5subtitle4,
                page5subtitle5: editableName.current.page5subtitle5,

                page6title: editableName.current.page6title,
                page6subtitle1: editableName.current.page6subtitle1,
                page6subtitle2: editableName.current.page6subtitle2,
                page6subtitle3: editableName.current.page6subtitle3,
                page6subtitle4: editableName.current.page6subtitle4,
                page6subtitle5: editableName.current.page6subtitle5,


                page7title: editableName.current.page7title,
                page7subtitle1: editableName.current.page7subtitle1,
                page7subtitle2: editableName.current.page7subtitle2,
                page7subtitle3: editableName.current.page7subtitle3,

                page8title: editableName.current.page8title,
                page8subtitle1: editableName.current.page8subtitle1,
                page8subtitle2: editableName.current.page8subtitle2,
                page8subtitle3: editableName.current.page8subtitle3,
                page8subtitle4: editableName.current.page8subtitle4,
                page8subtitle5: editableName.current.page8subtitle5,
                page8subtitle6: editableName.current.page8subtitle6,
                page8subtitle7: editableName.current.page8subtitle7,


                page9title: editableName.current.page9title,
                page9subtitle1: editableName.current.page9subtitle1,
                page9subtitle2: editableName.current.page9subtitle2,
                page9subtitle3: editableName.current.page9subtitle3,
                page9subtitle4: editableName.current.page9subtitle4,
                page9subtitle5: editableName.current.page9subtitle5,
                page9subtitle6: editableName.current.page9subtitle6,
                page9subtitle7: editableName.current.page9subtitle7,
                page9subtitle8: editableName.current.page9subtitle8,

                page10title: editableName.current.page10title,
                page10subtitle1: editableName.current.page10subtitle1,

                page11title: editableName.current.page11title,
                page11subtitle1: editableName.current.page11subtitle1,
            },

            other: {
                page4subtitle4: page4subtitle4,
                page5subtitle3: page5subtitle3,
                table3data2: table3data2,
                table4data: table4data,
                table5data: table5data,
                totalRisks: totalRisks

            },

            charts: {
                // If you want to store base64 chart images or data-driven chart inputs
                // Add them here, like:
                // page2Chart: chartData2,
                // riskByDepartment: general_dashboard_data.risks_by_department,
            },

            metadata: {
                createdAt: new Date().toISOString(),
                language: language, // if using internationalization
            }
        };
    }

    const loadReportJSON = (reportData) => {
        ////console.log("Attempting to load Saved Report", reportData)

        if (!reportData || typeof reportData !== "object") return;

        const editable = reportData.json.editableName || {};
        const other = reportData.json.other || {};

        if (editableName?.current) {
            editableName.current.title = editable.title || "";
            editableName.current.subtitle = editable.subtitle || "";

            editableName.current.page1title = editable.page1title || "";
            editableName.current.page1subtitle1 = editable.page1subtitle1 || "";
            editableName.current.page1subtitle2 = editable.page1subtitle2 || "";
            editableName.current.page1subtitle3 = editable.page1subtitle3 || "";
            editableName.current.page1subtitle4 = editable.page1subtitle4 || "";
            editableName.current.page1subtitle5 = editable.page1subtitle5 || "";


            editableName.current.page2title = editable.page2title || "";
            editableName.current.page2subtitle1 = editable.page2subtitle1 || "";
            editableName.current.page2subtitle2 = editable.page2subtitle2 || "";
            editableName.current.page2subtitle3 = editable.page2subtitle3 || "";
            editableName.current.page2subtitle4 = editable.page2subtitle4 || "";
            editableName.current.page2subtitle5 = editable.page2subtitle5 || "";
            editableName.current.page2subtitle6 = editable.page2subtitle6 || "";
            editableName.current.page2subtitle7 = editable.page2subtitle7 || "";
            editableName.current.page2subtitle8 = editable.page2subtitle8 || "";

            editableName.current.page3title = editable.page3title || "";
            editableName.current.page3subtitle1 = editable.page3subtitle1 || "";
            editableName.current.page3subtitle2 = editable.page3subtitle2 || "";
            editableName.current.page3subtitle3 = editable.page3subtitle3 || "";
            editableName.current.page3subtitle4 = editable.page3subtitle4 || "";
            editableName.current.page3subtitle5 = editable.page3subtitle5 || "";
            editableName.current.page3subtitle6 = editable.page3subtitle6 || "";

            editableName.current.page4title = editable.page4title || "";
            editableName.current.page4subtitle1 = editable.page4subtitle1 || "";
            editableName.current.page4subtitle2 = editable.page4subtitle2 || "";
            editableName.current.page4subtitle3 = editable.page4subtitle3 || "";

            editableName.current.page5title = editable.page5title || "";
            editableName.current.page5subtitle1 = editable.page5subtitle1 || "";
            editableName.current.page5subtitle2 = editable.page5subtitle2 || "";
            editableName.current.page5subtitle4 = editable.page5subtitle4 || "";
            editableName.current.page5subtitle5 = editable.page5subtitle5 || "";

            editableName.current.page6title = editable.page6title || "";
            editableName.current.page6subtitle1 = editable.page6subtitle1 || "";
            editableName.current.page6subtitle2 = editable.page6subtitle2 || "";
            editableName.current.page6subtitle3 = editable.page6subtitle3 || "";
            editableName.current.page6subtitle4 = editable.page6subtitle4 || "";
            editableName.current.page6subtitle5 = editable.page6subtitle5 || "";

            editableName.current.page7title = editable.page7title || "";
            editableName.current.page7subtitle1 = editable.page7subtitle1 || "";
            editableName.current.page7subtitle2 = editable.page7subtitle2 || "";
            editableName.current.page7subtitle3 = editable.page7subtitle3 || "";

            editableName.current.page8title = editable.page8title || "";
            editableName.current.page8subtitle1 = editable.page8subtitle1 || "";
            editableName.current.page8subtitle2 = editable.page8subtitle2 || "";
            editableName.current.page8subtitle3 = editable.page8subtitle3 || "";
            editableName.current.page8subtitle4 = editable.page8subtitle4 || "";
            editableName.current.page8subtitle5 = editable.page8subtitle5 || "";
            editableName.current.page8subtitle6 = editable.page8subtitle6 || "";
            editableName.current.page8subtitle7 = editable.page8subtitle7 || "";

            editableName.current.page9title = editable.page9title || "";
            editableName.current.page9subtitle1 = editable.page9subtitle1 || "";
            editableName.current.page9subtitle2 = editable.page9subtitle2 || "";
            editableName.current.page9subtitle3 = editable.page9subtitle3 || "";
            editableName.current.page9subtitle4 = editable.page9subtitle4 || "";
            editableName.current.page9subtitle5 = editable.page9subtitle5 || "";
            editableName.current.page9subtitle6 = editable.page9subtitle6 || "";
            editableName.current.page9subtitle7 = editable.page9subtitle7 || "";
            editableName.current.page9subtitle8 = editable.page9subtitle8 || "";

            editableName.current.page10title = editable.page10title || "";
            editableName.current.page10subtitle1 = editable.page10subtitle1 || "";

            editableName.current.page11title = editable.page11title || "";
            editableName.current.page11subtitle1 = editable.page11subtitle1 || "";
        }

        // Restore external variables
        if (typeof page4subtitle4 !== "undefined") setPage4subtitle4(other.page4subtitle4) || setPage4subtitle4("");
        if (typeof page5subtitle3 !== "undefined") setPage5subtitle3(other.page5subtitle3) || setPage5subtitle3("");
        if (typeof table3data2 !== "undefined") setTable3data2(other.table3data2) || setTable3data2("");
        if (typeof table4data !== "undefined") setTable4data(other.table4data) || setTable4data("");


    };


    return (


        <div className="p-6 bg-white rounded-lg">
            {loading && <div className="flex justify-center items-center h-[50vh]">
                <img src={spinner} alt="Loading..." className="w-8 h-8" />
                <p className="ml-4 text-sm text-[#3b3b3b]">Generating Report...</p>
            </div>}
            {(!loading && parsing) && <div id="report-container" >
                {/* Title and Definition */}
                <div className="flex justify-between mb-4">
                    <div className="flex items-center gap-4">
                        <div className="relative inline-block text-left">
                            <button
                                type="button"
                                className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                disabled={exporting} // disable while exporting to prevent double click
                            >
                                {exporting ? "Generating PDF..." : "Export PDF ▾"}
                            </button>

                            {dropdownOpen && !exporting && (
                                <div className="absolute left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                                    <button
                                        className="w-full text-left px-4 py-3 text-sm text-[#3b3b3b] font-medium hover:bg-blue-50 transition rounded-md"
                                        onClick={handleExportV}
                                    >
                                        Export Visual PDF
                                    </button>

                                    <button
                                        className="w-full text-left px-4 py-3 text-sm text-[#3b3b3b] font-medium hover:bg-blue-50 transition rounded-md"
                                        onClick={handleExportP}
                                    >
                                        Export Print PDF
                                    </button>
                                </div>
                            )}
                        </div>


                        <select
                            value={language}
                            onChange={handleLanguageChange}
                            className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#3b3b3b]"
                        >
                            <option value="en">English</option>
                            <option value="tr">Türkçe</option>
                        </select>
                    </div>

                    <button onClick={() => closeReport(generateReportJSON())} className="">
                        <img src={CloseIcon} alt="Close" className="w-8 h-8" />
                    </button>
                </div>



                <div className="w-full" ref={componentRef} id="report-container">

                    <div id="page1" className="relative h-[500px]"> {/* Ensure the parent has height */}
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url("${greenMountain}")` }}
                        ></div>
                        
                        <div className="relative z-10 flex items-center justify-center h-full"> {/* Full height for content alignment */}
                            <div className="border-2 border-white rounded-lg p-2">
                                <ContentEditable
                                    html={editableName.current.title}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    onChange={(e) => {
                                        ////////console.log(e.target.value);
                                        editableName.current.title = e.target.value;
                                    }}
                                    tagName="h1"
                                    style={{
                                        color: "white",
                                        fontSize: "2rem",
                                        fontWeight: "bold",
                                    }}
                                />


                                <div className="flex items-center">
                                    <ContentEditable
                                        html={
                                            editableName.current.subtitle
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.subtitle = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "white",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr className="my-4"></hr>
                    <div id="page2" className="h-auto">
                        <div className="border-2 border-white rounded-lg ">
                            {/* <ReactQuill
                            ref={editorRef}
                            //value={editableName.current.page1title}
                            onChange={(value) => {
                            editableName.current.page1title = value;
                            }}
                            defaultValue={{
                                ops: [
                                { insert: editableName.current.page1title, attributes: { size: "large", bold: true } }, 
                                { insert: "\n" } // Ensures correct rendering
                                ]
                            }}
                            modules={{
                            toolbar: {
                                container: [
                                ["bold", "italic", "underline"],
                                [{ size: ["small", false, "large"] }],
                                [{ align: [] }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ],
                            },
                            }}
                            contentStyle={{ size: "large" }} 
                            theme="snow"
                            className={activeBox === "page1title" ? "show-toolbar" : "hide-toolbar"}
                            onFocus={() => setActiveBox("page1title")}
                            onBlur={(e) => {
                                setTimeout(() => {
                                  const activeElement = document.activeElement;
                                  if (!activeElement || !activeElement.closest('.ql-toolbar')) {
                                    setActiveBox(null);
                                  }
                                }, 0); }}
                            style={{
                                color: "#2E7D32",
                                maxWidth: "600px", // Use maxWidth for better responsiveness
                            }}
                        /> */}
                            <ContentEditable
                                html={editableName.current.page1title}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        e.target.blur(); // Optional: blur on Enter
                                    }
                                }}
                                onChange={(e) => {
                                    editableName.current.page1title = e.target.value;
                                }}
                                tagName="h1" // Use h1 or p depending on your semantic needs
                                onFocus={() => setActiveBox("page1title")}
                                onBlur={(e) => {
                                    setTimeout(() => {
                                        const activeElement = document.activeElement;
                                        if (!activeElement || !activeElement.closest('.ql-toolbar')) {
                                            setActiveBox(null);
                                        }
                                    }, 0);
                                }}
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "600px",
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page1subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page1subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}

                            />


                            <ContentEditable
                                html={
                                    editableName.current.page1subtitle2
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page1subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page1subtitle3
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page1subtitle3 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                            <div className="grid grid-cols-2 gap-4">
                                <div className="col-span-1">
                                    <ContentEditable
                                        html={
                                            editableName.current.page1subtitle4
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page1subtitle4 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#2E7D32",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                    <ContentEditable
                                        html={
                                            editableName.current.page1subtitle5
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page1subtitle5 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                </div>
                                <div className="col-span-1 flex items-center justify-center h-full">
                                    <img src={page1chart} alt="Page 1 Chart" className="w-full h-auto max-w-full" />
                                </div>
                            </div>

                        </div>
                    </div>




                    <hr className="my-4"></hr>
                    <div id="page3" className="h-auto">
                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page2title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page2title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page2subtitle1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page2subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />
                            <ContentEditable
                                html={editableName.current.page2subtitle2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page2subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            <div className="grid grid-cols-3 gap-4">
                                <div className="col-span-1">

                                    <ContentEditable
                                        html={editableName.current.page2subtitle3}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle3 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={editableName.current.page2subtitle4}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle4 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />



                                </div>
                                <div className="col-span-1">

                                    <img src={page2chart} alt="Page 2 Chart" className="w-full h-auto max-w-full" />

                                    <ContentEditable
                                        html={editableName.current.page2subtitle7}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle7 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={editableName.current.page2subtitle8}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle8 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />



                                </div>


                                <div className="col-span-1">

                                    <ContentEditable
                                        html={editableName.current.page2subtitle5}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle5 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />
                                    <ContentEditable
                                        html={editableName.current.page2subtitle6}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page2subtitle6 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                </div>

                            </div>

                        </div>
                    </div>



                    <hr className="my-4"></hr>
                    <div id="page4" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page3title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page3subtitle1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page3subtitle2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />


                            <ContentEditable
                                html={editableName.current.page3subtitle3}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                            <div className="grid grid-cols-2 gap-4">

                                <div className="col-span-1">
                                    <img src={page3chart} alt="Page 3 Chart" className="w-full h-auto max-w-full" />

                                </div>

                                <div className="col-span-1 flex items-center justify-center">
                                    <ContentEditable
                                        html={editableName.current.page3subtitle4}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page3subtitle4 = e.target.value;
                                        }}
                                        tagName="div"
                                        style={{
                                            textAlign: "left", // Center text within the div
                                        }}
                                    />
                                </div>

                            </div>


                            <ContentEditable
                                html={editableName.current.page3subtitle5}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3subtitle5 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                            <ContentEditable
                                html={editableName.current.page3subtitle6}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page3subtitle6 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                        </div>
                    </div>




                    <hr className="my-4"></hr>
                    <div id="page5" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page4title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page4title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page4subtitle1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page4subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                            <div className="grid grid-cols-2 gap-4">

                                <div className="col-span-1">
                                    <img src={page4chart} alt="Page 4 Chart" className="w-full h-auto max-w-full" />

                                </div>


                                <div className="col-span-1">

                                    <ContentEditable
                                        html={editableName.current.page4subtitle2}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page4subtitle2 = e.target.value;
                                        }}
                                        tagName="div"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />

                                </div>




                            </div>


                            <ContentEditable
                                html={editableName.current.page4subtitle3}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page4subtitle3 = e.target.value;
                                }}
                                tagName="div"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                            <ContentEditable
                                html={page4subtitle4}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    page4subtitle4 = e.target.value;
                                }}
                                tagName="div"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />


                        </div>
                    </div>





                    <hr className="my-4"></hr>
                    <div id="page6" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page5title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page5title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page5subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page5subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page5subtitle2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page5subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />



                            <ContentEditable
                                html={page5subtitle3}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    page5subtitle3 = e.target.value;
                                }}
                                tagName="div"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />

                            <ContentEditable
                                html={editableName.current.page5subtitle4}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page5subtitle4 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                    marginRight: "10px", // Add some space between the two elements
                                }}
                            />


                            <div className="grid grid-cols-2 gap-4">

                                <div className="col-span-1 flex items-center justify-center h-full">
                                    <ContentEditable
                                        html={editableName.current.page5subtitle5}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page5subtitle5 = e.target.value;
                                        }}
                                        tagName="div"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "bold",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                            marginRight: "10px", // Add some space between the two elements
                                        }}
                                    />
                                </div>


                                <div className="col-span-1">

                                    <img src={page5chart} alt="Page 5 Chart" className="w-full h-auto max-w-full" />


                                </div>




                            </div>



                        </div>
                    </div>






                    <hr className="my-4"></hr>
                    <div id="page7" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page6title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page6title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page6subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page6subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page6subtitle2
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page6subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />




                            <div className="grid grid-cols-5 gap-4">

                                <div className="col-span-2">

                                    <ContentEditable
                                        html={
                                            language === "en" ? "Number of Risk By Departments" : "Departmanlara Göre Risklerin Dağılımı"
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            //////////console.log(e.target.value);
                                            //editableName.current.page6subtitle2 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                    <RiskByDepartment height={(window.innerHeight - 400) / 2} risks_by_department={general_dashboard_data.risks_by_department} />

                                    <ContentEditable
                                        html={
                                            language === "en" ? `As seen above risk our company currently manages ${total_risks} identified risks, distributed across key departments.The ${general_dashboard_data && general_dashboard_data.risks_by_department && general_dashboard_data.risks_by_department[0].name} holds the highest ratio, followed closely by ${general_dashboard_data && general_dashboard_data.risks_by_department && general_dashboard_data?.risks_by_department[1]?.value}% ${general_dashboard_data && general_dashboard_data.risks_by_department && general_dashboard_data.risks_by_department[1].name}.`
                                                : `Yukarıda görüldüğü üzere, şirketimiz şu anda toplam ${total_risks} tanımlanmış riski yönetmektedir ve bu riskler kilit departmanlara dağılmış durumdadır. En yüksek orana sahip olan departman ${general_dashboard_data?.risks_by_department?.[0].name}, onu %${general_dashboard_data?.risks_by_department?.[1].value} oranıyla ${general_dashboard_data?.risks_by_department?.[1].name} departmanı takip etmektedir.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            //////////console.log(e.target.value);
                                            //editableName.current.page6subtitle2 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                    <ContentEditable
                                        html={
                                            language === "en" ? "Residual Risk Level by Departments" : "Departmanlara Göre Kalıcı Risk Seviyesi"
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            //////////console.log(e.target.value);
                                            //editableName.current.page6subtitle2 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                    <RiskLevelByDepartment height={(window.innerHeight - 375) / 2} data={general_dashboard_data.risk_level_by_department} />


                                </div>

                                <div className="col-span-1"> {/* Adjusted width to make the column smaller */}

                                    <ContentEditable
                                        html={
                                            editableName.current.page6subtitle3
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page6subtitle3 = e.target.value;
                                        }}
                                        tagName="div"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                </div>

                                <div className="col-span-2"> {/* Increased width by changing col-span from 1 to 2 */}

                                    <RiskLineChart height={(window.innerHeight - 375) / 2} data={general_dashboard_data.risk_assessment_history} />

                                    <ContentEditable
                                        html={
                                            editableName.current.page6subtitle4
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page6subtitle4 = e.target.value;
                                        }}
                                        tagName="div"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                    <div className="grid grid-cols-2 gap-4">

                                        <div className="col-span-1">

                                            <ContentEditable
                                                html={
                                                    editableName.current.page6subtitle5
                                                }
                                                disabled={false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        ////////console.log('Enter key pressed');
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    ////////console.log(e.target.value);
                                                    editableName.current.page6subtitle5 = e.target.value;
                                                }}
                                                tagName="div"
                                                style={{
                                                    color: "#000",
                                                    fontSize: "1rem",
                                                    fontWeight: "normal",
                                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                                }}
                                            />

                                        </div>



                                        <div className="col-span-1">

                                            <RiskAppetite height={(window.innerHeight - 375) / 2} risk_appetite={general_dashboard_data.risk_appetite} />

                                        </div>


                                    </div>


                                </div>




                            </div>



                        </div>
                    </div>









                    <hr className="my-4"></hr>
                    <div id="page8" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page7title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page7title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    activeDepartment + " Department"
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page6subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page7subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page7subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            <div className="grid grid-cols-3 gap-4">

                                <div className="col-span-1">

                                    {/* <Card7 card_data={department_dashboard_data && department_dashboard_data.card_data} /> */}

                                    <ActionStatus height={(window.innerHeight - 550) / 2} data={department_dashboard_data.action_status} />

                                    <ContentEditable
                                        // html={
                                        //     `The ${activeDepartment} department, led by Manager Andrei Ucozz consists of ${department_dashboard_data && department_dashboard_data.card_data && department_dashboard_data.card_data.personnel_number} members who manage ${department_dashboard_data && department_dashboard_data.card_data && department_dashboard_data.card_data.risk_count} identified risks, ${department_dashboard_data && department_dashboard_data.card_data && department_dashboard_data.card_data.control_count} controls, and ${department_dashboard_data && department_dashboard_data.card_data && department_dashboard_data.card_data.action_count} ongoing actions.Despite their proactive efforts, the department remains exposed to risks due to the ever - changing technological landscape.Strengthening controls and maintaining focus on risk management initiatives will be essential to reducing vulnerabilities and ensuring robust ${activeDepartment} security and operations.`
                                        // }
                                        html={
                                            language === 'en' ? `In the ${activeDepartment} department, action items are monitored to ensure timely completion. Currently, ${department_dashboard_data.action_status[0]
                                                ? parseFloat(department_dashboard_data.action_status[0].percentage).toFixed(1)
                                                : "0"
                                                }% of actions are scheduled to be completed within the next 30 days, demonstrating proactive planning. However, ${department_dashboard_data.action_status[1]
                                                    ? parseFloat(department_dashboard_data.action_status[1].percentage).toFixed(1)
                                                    : "0"
                                                }% of actions are overdue by 0 to 30 days, and an additional ${department_dashboard_data.action_status[2]
                                                    ? parseFloat(department_dashboard_data.action_status[2].percentage).toFixed(1)
                                                    : "0"
                                                }% have been overdue for 30 to 60 days. These figures underscore the importance of addressing overdue items to maintain operational efficiency and meet departmental goals.` : `Departmanımızda, eylemlerin zamanında tamamlanmasını sağlamak için izlenmektedir. Şu anda, ${department_dashboard_data.action_status[0]
                                                    ? parseFloat(department_dashboard_data.action_status[0].percentage).toFixed(1)
                                                    : "0"
                                                }% eylem planlanmıştır. Bu eylemlerin %${department_dashboard_data.action_status[1]
                                                    ? parseFloat(department_dashboard_data.action_status[1].percentage).toFixed(1)
                                                    : "0"
                                            }'i 0-30 gün içinde gecikmiştir ve %${department_dashboard_data.action_status[2]
                                                ? parseFloat(department_dashboard_data.action_status[2].percentage).toFixed(1)
                                                : "0"
                                            }'i 30-60 gün içinde gecikmiştir. Bu rakamlar, gecikmiş eylemleri ele almak için operasyonel verimliliği ve departman hedeflerini korumak için önemini vurgular.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                </div>

                                <div className="col-span-1">

                                    <RiskSummary height={(window.innerHeight - 450) / 2} data={department_dashboard_data.risk_summary} />

                                    <ContentEditable
                                        html={
                                            language === 'en' ?
                                                `The ${activeDepartment} department's risk assessment reveals an inherent financial risk score of ${department_dashboard_data.risk_summary[1]['Inherent']}, operational risk score of ${department_dashboard_data.risk_summary[0]['Inherent']} and reputational risk score of ${department_dashboard_data.risk_summary[2]['Inherent']}, indicating significant exposure in these areas before controls are applied. After mitigation efforts, the average residual risk scores have been successfully reduced to ${department_dashboard_data.risk_summary[1]['Residual']}, ${department_dashboard_data.risk_summary[0]['Residual']} and ${department_dashboard_data.risk_summary[2]['Residual']}, respectively, reflecting the department's proactive management of current risks.Looking ahead, future risk projections show further reductions, with anticipated average scores of ${department_dashboard_data.risk_summary[1]['Future']} for operational risks, ${department_dashboard_data.risk_summary[0]['Future']} for financial risks, and ${department_dashboard_data.risk_summary[2]['Future']} for reputational risks, demonstrating the effectiveness of ongoing strategies and a commitment to maintaining a robust risk management framework.`
                                                :
                                                `${activeDepartment} departmanının risk değerlendirmesi, kontroller uygulanmadan önce bu alanlarda önemli bir risk maruziyetini gösteren ${department_dashboard_data.risk_summary[1]['Inherent']} finansal risk puanı, ${department_dashboard_data.risk_summary[0]['Inherent']} operasyonel risk puanı ve ${department_dashboard_data.risk_summary[2]['Inherent']} itibar riski puanı ortaya koymaktadır. Risk azaltma çalışmalarından sonra, ortalama kalıntı risk puanları sırasıyla ${department_dashboard_data.risk_summary[1]['Residual']}, ${department_dashboard_data.risk_summary[0]['Residual']} ve ${department_dashboard_data.risk_summary[2]['Residual']}'e başarıyla düşürülmüş olup, bu durum departmanın mevcut riskleri proaktif yönetimini yansıtmaktadır. Geleceğe bakıldığında, risk projeksiyonları operasyonel riskler için ${department_dashboard_data.risk_summary[1]['Future']}, finansal riskler için ${department_dashboard_data.risk_summary[0]['Future']} ve itibar riskleri için ${department_dashboard_data.risk_summary[2]['Future']} beklenen ortalama puanlarla daha fazla azalma göstermekte olup, bu durum devam eden stratejilerin etkinliğini ve güçlü bir risk yönetimi çerçevesini sürdürme taahhüdünü göstermektedir.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                </div>

                                <div className="col-span-1">


                                    <TopRisks height={(window.innerHeight - 450) / 2} data={department_dashboard_data.top_5_compliance_risks} />

                                    <ContentEditable
                                        // html={
                                        //     language === 'en' ? `Our strategic objectives are at risk due to virus threats, which can disrupt operations and compromise data security; intellectual property theft, endangering proprietary knowledge and competitive advantage; and weak passwords / authentication, exposing systems to breaches.Mitigating these risks is crucial to safeguarding our operations, protecting critical assets, and sustaining long - term growth and resilience.` : `Stratejik hedeflerimiz virüs tehditleri nedeniyle risk altındadır, bu tehditler işletimleri ve veri güvenliğini tehlikeye atabilir; bilgi mülkiyeti çalınması, mülkiyet bilgilerini ve rekabet avantajını tehlikeye atabilir; ve zayıf parolalar / kimlik doğrulama, sistemleri tehlikeye atabilir. Bu riskleri azaltmak, işletimlerimizi korumanıza, kritik varlıkları korumanıza ve uzun vadeli büyüme ve dayanıklılığı sürdürmenize yardımcı olmak için kritiktir.`
                                        // }
                                        html={formatTopRisksParagraph(department_dashboard_data.top_5_compliance_risks, language)}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                </div>
                            </div>



                            <div className="flex items-center bg-red-400 text-white p-2 justify-center mt-4">
                                <h1 className="m-0 text-lg font-bold">{language === 'en' ? 'Guarding Against the Greatest Threats – Securing Today, Protecting Tomorrow!' : 'En Büyük Tehditleri Koruyarak Bugünü Koruyarak, Yarını Koruyarak'}</h1>
                            </div>


                        </div>
                    </div>








                    <hr className="my-4"></hr>
                    <div id="page9" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page7title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page7title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    activeDepartment + " Department"
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page6subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page7subtitle3
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page7subtitle3 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            <div className="grid grid-cols-3 gap-4">

                                <div className="col-span-1">

                                    <RiskSummaryReport type="financial" height={(window.innerHeight - 450) / 2} data={department_dashboard_data.summary_for_report} />

                                    <ContentEditable
                                        html={
                                            language === 'en' ? `In our <b> financial risk assessment</b >, we identified ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} total risks.Initially, the risk level before control(inherent risk) levels included ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} high and ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} extreme risks, highlighting significant vulnerabilities.After implementing control and mitigation measures, the residual risk levels were reduced to more acceptable levels: ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low, ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate, and ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "High" ? sum + item.count : sum, 0)} high risks.However, our target is to further minimize these risks, aiming for ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low and ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate levels, ensuring a more stable and manageable risk profile aligned with our organizational goals.`
                                                :
                                                `<b>Finansal risk değerlendirmemizde</b>, toplam ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} risk tespit edildi. Başlangıçta, kontrol öncesi risk seviyeleri (doğal risk) ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} yüksek ve ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} aşırı risk içeriyordu ve bu önemli kırılganlıkları vurguluyordu. Kontrol ve azaltma önlemlerinin uygulanmasından sonra, kalıntı risk seviyeleri daha kabul edilebilir seviyelere indirildi: ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük, ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta ve ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "High" ? sum + item.count : sum, 0)} yüksek risk. Ancak, hedefimiz bu riskleri daha da minimize etmek, ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük ve ${department_dashboard_data.summary_for_report.financial.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta seviyeye ulaşmak ve böylece kurumsal hedeflerimizle uyumlu daha istikrarlı ve yönetilebilir bir risk profili sağlamaktır.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                </div>

                                <div className="col-span-1">

                                    <RiskSummaryReport type="operational" height={(window.innerHeight - 450) / 2} data={department_dashboard_data.summary_for_report} />


                                    <ContentEditable
                                        html={
                                            language === 'en' ? `In our <b> operational risk assessment</b >, we identified a total of ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} risks.The initial inherent risk levels consisted of ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate, ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} high, and ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} extreme risk, indicating critical operational vulnerabilities.After applying control and mitigation measures, the risk levels were reduced to more acceptable levels: ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low and ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate risks.Our target is to further reduce these risks to achieve ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low and ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate levels, aligning with our risk appetite and operational stability objectives.`
                                                :
                                                `<b>Operasyonel risk değerlendirmemizde</b> toplam ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} risk tespit edildi. Başlangıçtaki doğal risk seviyeleri ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta, ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} yüksek ve ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} aşırı risk içeriyordu ve bu kritik operasyonel kırılganlıkları gösteriyordu. Kontrol ve azaltma önlemlerinin uygulanmasından sonra, risk seviyeleri daha kabul edilebilir seviyelere indirildi: ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük ve ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta risk. Hedefimiz, risk iştahımız ve operasyonel istikrar hedeflerimizle uyumlu olarak, bu riskleri daha da azaltarak ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük ve ${department_dashboard_data.summary_for_report.operational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta seviyeye ulaşmaktır.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />



                                </div>

                                <div className="col-span-1">

                                    <RiskSummaryReport type="reputational" height={(window.innerHeight - 450) / 2} data={department_dashboard_data.summary_for_report} />


                                    <ContentEditable
                                        html={
                                            language === 'en' ?
                                                `In our <b>reputational risk assessment</b>, we identified a total of ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} risks.Initially, the inherent risk levels included ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} high and ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} extreme risk, reflecting significant threats to our reputation.Following control and mitigation measures, the risks were reduced to more acceptable levels: ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low, ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate, and ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "High" ? sum + item.count : sum, 0)} high risks.Our target is to further reduce these risks to achieve ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} low and ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} moderate levels, ensuring a more resilient reputation aligned with our strategic goals.`
                                                :
                                                `<b>İtibar riski değerlendirmemizde</b> toplam ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" ? sum + item.count : sum, 0)} risk tespit edildi. Başlangıçta, doğal risk seviyeleri ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "High" ? sum + item.count : sum, 0)} yüksek ve ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Inherent" && item.risk_category === "Extreme" ? sum + item.count : sum, 0)} aşırı risk içeriyordu ve bu itibarımıza yönelik önemli tehditleri yansıtıyordu. Kontrol ve azaltma önlemlerinin uygulanmasından sonra, riskler daha kabul edilebilir seviyelere indirildi: ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük, ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta ve ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Residual" && item.risk_category === "High" ? sum + item.count : sum, 0)} yüksek risk. Hedefimiz, stratejik hedeflerimizle uyumlu daha dayanıklı bir itibar sağlamak için bu riskleri daha da azaltarak ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Low" ? sum + item.count : sum, 0)} düşük ve ${department_dashboard_data.summary_for_report.reputational.reduce((sum, item) => item.assessment_type === "Future" && item.risk_category === "Moderate" ? sum + item.count : sum, 0)} orta seviyeye ulaşmaktır.`
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            ////////console.log(e.target.value);
                                            editableName.current.page7subtitle1 = e.target.value;
                                        }}
                                        tagName="p"
                                        style={{
                                            color: "#000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "100%", // Use maxWidth for better responsiveness
                                        }}
                                    />

                                </div>
                            </div>



                            <div className="flex items-center bg-red-400 text-white p-2 justify-center mt-4">
                                <h1 className="m-0 text-lg font-bold">{language === 'en' ? 'Guarding Against the Greatest Threats – Securing Today, Protecting Tomorrow!' : 'En Büyük Tehditleri Koruyarak Bugünü Koruyarak, Yarını Koruyarak'}</h1>
                            </div>


                        </div>
                    </div>







                    <hr className="my-4"></hr>

                    <div id="page10" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page8title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle2
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            {/* table here */}



                            <ContentEditable
                                html={table1data}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />


                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle3
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle3 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                        </div>
                    </div>





                    <hr className="my-4"></hr>

                    <div id="page11" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page8title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle4
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle4 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle5
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle5 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            <ContentEditable
                                html={table2data1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />


                             {/* <ContentEditable
                                html={table7data}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            /> */}




                            <ContentEditable
                                html={
                                    editableName.current.page8title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle6
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle6 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page8subtitle7
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle7 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={table3data1}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />



                        </div>
                    </div>







                    <hr className="my-4"></hr>
                    <div id="page12" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page9title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle2
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle2 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            {/* table here */}



                            <ContentEditable
                                html={table1data2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />


                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle3
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page8subtitle3 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                        </div>
                    </div>





                    <hr className="my-4"></hr>
                    <div id="page11" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page9title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle4
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle4 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />

                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle5
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle5 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />



                            <ContentEditable
                                html={table2data2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />






                        </div>
                    </div>









                    <hr className="my-4"></hr>
                    <div id="page12" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page9title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle6
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle6 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page9subtitle7
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page9subtitle7 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={table3data2}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />






                        </div>
                    </div>






                    <hr className="my-4"></hr>
                    <div id="page13" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page10title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page10title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page10subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page10subtitle1 = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "normal",
                                    maxWidth: "100%", // Use maxWidth for better responsiveness
                                }}
                            />




                            <ContentEditable
                                html={table4data}
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}

                                tagName="div"

                            />






                        </div>
                    </div>






                    <hr className="my-4"></hr>
                    <div id="page14" className="h-auto">

                        <div className="border-2 border-white rounded-lg">
                            <ContentEditable
                                html={
                                    editableName.current.page11title
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page11title = e.target.value;
                                }}
                                tagName="p"
                                style={{
                                    color: "#2E7D32",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    maxWidth: "300px", // Use maxWidth for better responsiveness
                                }}
                            />


                            <ContentEditable
                                html={
                                    editableName.current.page11subtitle1
                                }
                                disabled={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        ////////console.log('Enter key pressed');
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    ////////console.log(e.target.value);
                                    editableName.current.page11subtitle1 = e.target.value;
                                }}
                                tagName="div"

                            />

                            <div className="grid grid-cols-2 gap-4">
                                <div className="col-span-1">

                                    <ContentEditable
                                        html={language === "en" ? `Sincerely<br/>${moment().format('DD.MM.YYYY')}` : `Saygılarımızla<br/>${moment().format('DD.MM.YYYY')}`}
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}

                                        tagName="p"
                                        style={{
                                            color: "#000000",
                                            fontSize: "1rem",
                                            fontWeight: "normal",
                                            maxWidth: "300px", // Use maxWidth for better responsiveness
                                        }}
                                    />


                                </div>
                                <div className="col-span-1">

                                    <ContentEditable
                                        html={
                                            ''
                                        }
                                        disabled={false}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                ////////console.log('Enter key pressed');
                                                e.target.blur();
                                            }
                                        }}

                                        tagName="div"

                                    />

                                </div>
                            </div>








                        </div>
                    </div>
                    <hr className="my-4"></hr>

                    <div id="page15" className="relative h-[500px]"> {/* Ensure the parent has height */}
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url("${greenMountain}")` }}
                        ></div>
                      
                        <div className="relative z-10 flex flex-col items-center justify-center h-full"> {/* Full height for content alignment */}
                            <div className="border-2 border-white rounded-lg p-2">
                                <ContentEditable
                                    html={"FIN AND FIND RISK TEAM"}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    onChange={(e) => {
                                        ////////console.log(e.target.value);
                                        editableName.current.title = e.target.value;
                                    }}
                                    tagName="h1"
                                    style={{
                                        color: "white",
                                        fontSize: "2rem",
                                        fontWeight: "bold",
                                    }}
                                />

                            </div>


                            <div className="relative z-10 flex items-center justify-center mt-6"> {/* Full height for content alignment */}
                                <ContentEditable
                                    html={language === "en" ? `Empowering Decisions Through Insightful Risk Management – Together Towards a Secure Future` : `Karar Vermeye İzin Verici Risk Yönetimi – Birlikte Geleceğe Güven`}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            ////////console.log('Enter key pressed');
                                            e.target.blur();
                                        }
                                    }}
                                    tagName="p"
                                    style={{
                                        color: "#ffffff",
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        maxWidth: "100%", // Use maxWidth for better responsiveness
                                    }}
                                />



                            </div>

                        </div>


                    </div>




                </div >

            </div >}

        </div >
    );
};

const mapStateToProps = (state) => {

    // 1.  Fallback to an empty array
    const allDeps = state.department.departments ?? [];   // null/undefined → []
    const dep = allDeps.find(d => d.department_id === state.department.activeDepartmentId);

    const allCompliance = state.compliance.complianceStandards ?? [];
    const compliance = allCompliance.find(
        c => c.compliance_id === state.compliance.activeComplianceId
    );

    //console.log("Report Data", state)
    return {

        general_dashboard_data: state.dashboard.general_dashboard_data,
        department_dashboard_data: state.dashboard.compliance_dashboard_data,
        risks_report: state.risk.risks_report,
        risk_controls: state.risk.risk_controls,
        risk_actions: state.risk.risk_actions,
        risk_incidents: state.risk.risk_incidents,
        findings: state.department.finding_data?.findings,
        levels: state.risk.levels,
        activeDepartment: compliance ? compliance.name : "N/A",
        activeComplianceId: state.compliance.activeComplianceId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getGeneralDashboardDataFN: () => dispatch(getGeneralDashboardData()),
        getDepartmentDashboardDataFN: (activeDepartmentId) => dispatch(getDepartmentDashboardData(activeDepartmentId)),
        getComplianceDashboardDataFN:(c) => dispatch(getComplianceDashboardData(c)),
        getRisks_ReportFN: (department_id) => dispatch(getRisks_Report(department_id)),
        getRisks_Report_ByComplianceFN: (c) => dispatch(getRisks_Report_ByCompliance(c)),
        getControls_Report_ByComplianceFN: (c) => dispatch(getControls_Report_ByCompliance(c)),
        getControls_ReportFN: (department_id) => dispatch(getControls_Report(department_id)),
        getActions_ReportFN: (department_id) => dispatch(getActions_Report(department_id)),
        getActions_Report_ByComplianceFN: (c) => dispatch(getActions_Report_ByCompliance(c)),
        getIncidents_ReportFN: (department_id) => dispatch(getIncidents_Report(department_id)),
        getIncidents_Report_ByComplianceFN:(c) =>dispatch(getIncidents_Report_ByCompliance(c)),
        getLevelsFN: () => dispatch(getLevels()),
        getReportsFN: () => dispatch(getReports()),
        getReportFN: (id) => dispatch(getReport(id)),
        createReportFN: (title, json, type) => dispatch(createReport(title, json, type)),
        deleteReportFN: () => dispatch(deleteReport()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(ReportOverlay);